export const eventList = [
    ["7.1 Patch Compensation","2026-09-22",600],
    ["Vesna/Vodyanitsa Trial","2026-09-22",40],
    ["Archon Quest Act 6 Ch 3","2026-09-22",190],
    ["Archon Quest Act 6 Ch 4","2026-09-22",750],
    ["Miliastra Wonderland Treasures","2026-09-22",60],
    ["Silverlight in Pursuit of the Moon","2026-09-23",310],
    ["Vesna Patrol Mission","2026-09-24",40],
    ["Silverlight in Pursuit of the Moon","2026-09-25",340],
    ["Silverlight in Pursuit of the Moon","2026-09-27",300],
    ["Anniversary Memories","2026-09-28",150],
    ["Anniversary: Missive of Grace","2026-09-28",400],
    ["Anniversary: Missive of Grace","2026-09-29",400],
    ["Stygian Onslaught","2026-09-30",450],
    ["Anniversary: Missive of Grace","2026-09-30",400],
    ["Starlit Gala","2026-10-01",20],
    ["Anniversary: Missive of Grace","2026-10-01",400],
    ["Anniversary: Resplendent Starlight","2026-10-01",160],
    ["Anniversary: Resplendent Starlight","2026-10-03",320],
    ["Mihoyo Web Login","2026-10-03",20],
    ["Vesna Patrol Mission","2026-10-04",0],
    ["Anniversary: Resplendent Starlight","2026-10-05",320],
    ["Anniversary: Resplendent Starlight","2026-10-07",800],
    ["Mihoyo Web Login","2026-10-10",20],
    ["Silverlight in Pursuit of the Moon","2026-10-12",0],
    ["Predictive Victory Dynamics","2026-10-12",20],
    ["Skirk/Escoffier Trial","2026-10-13",40],
    ["Predictive Victory Dynamics","2026-10-13",60],
    ["Predictive Victory Dynamics","2026-10-14",60],
    ["Predictive Victory Dynamics","2026-10-15",60],
    ["Predictive Victory Dynamics","2026-10-16",80],
    ["Predictive Victory Dynamics","2026-10-17",60],
    ["Mihoyo Web Login","2026-10-17",20],
    ["Predictive Victory Dynamics","2026-10-18",20],
    ["Anniversary Memories","2026-10-18",0],
    ["Predictive Victory Dynamics","2026-10-19",60],
    ["Carefree Snowball Fight","2026-10-21",140],
    ["Starlit Gala","2026-10-22",0],
    ["Carefree Snowball Fight","2026-10-23",140],
    ["7.2 Livestream Codes","2026-10-23",300],
    ["7.2 Livestream Codes","2026-10-24",0],
    ["Carefree Snowball Fight","2026-10-25",140],
    ["Mihoyo Web Login","2026-11-03",20],
    ["7.2 Patch Compensation","2026-11-03",600],
];

// eslint-disable-next-line no-unused-vars
const past_events = [
    ["Contending Tides","2021-04-02",60],
    ["Contending Tides","2021-04-03",60],
    ["Contending Tides","2021-04-04",60],
    ["Contending Tides","2021-04-05",60],
    ["Contending Tides","2021-04-06",60],
    ["Mihoyo Web Login","2021-04-06",20],
    ["Contending Tides","2021-04-07",60],
    ["Contending Tides","2021-04-08",60],
    ["Wishful Drops","2021-04-09",120],
    ["Wishful Drops","2021-04-10",60],
    ["Wishful Drops","2021-04-11",60],
    ["Wishful Drops","2021-04-12",60],
    ["Wishful Drops","2021-04-13",120],
    ["Archon Quest Act 1 Ch 4","2021-04-12",60],
    ["Mihoyo Web Login","2021-04-13",20],
    ["1.5 Livestream Codes","2021-04-16",300],
    ["Marvelous Merchandise","2021-04-16",40],
    ["Marvelous Merchandise","2021-04-17",40],
    ["Marvelous Merchandise","2021-04-18",40],
    ["Marvelous Merchandise","2021-04-19",40],
    ["Marvelous Merchandise","2021-04-20",140],
    ["Mihoyo Web Login","2021-04-20",20],
    ["Marvelous Merchandise","2021-04-21",40],
    ["Marvelous Merchandise","2021-04-22",40],
    ["1.5 Patch Compensation","2021-04-28",600],
    ["Marvelous Merchandise","2021-04-16",40],
    ["Marvelous Merchandise","2021-04-17",40],
    ["Marvelous Merchandise","2021-04-18",40],
    ["Marvelous Merchandise","2021-04-19",40],
    ["Marvelous Merchandise","2021-04-20",140],
    ["Mihoyo Web Login","2021-04-20",20],
    ["Marvelous Merchandise","2021-04-21",40],
    ["Marvelous Merchandise","2021-04-22",40],
    ["1.5 Patch Compensation","2021-04-27",600],
    ["Zhongli Trial","2021-04-27",20],
    ["Energy Amplifier Initiation","2021-04-30",60],
    ["Energy Amplifier Initiation","2021-05-04",60],
    ["Mihoyo Web Login","2021-05-06",20],
    ["Energy Amplifier Initiation","2021-05-08",60],
    ["Energy Amplifier Initiation","2021-05-12",60],
    ["Mihoyo Web Login","2021-05-13",20],
    ["Windtrace","2021-05-14",120],
    ["Windtrace","2021-05-15",60],
    ["Windtrace","2021-05-16",60],
    ["Windtrace","2021-05-17",60],
    ["Energy Amplifier Initiation","2021-05-17",60],
    ["Eula Trial","2021-05-18",20],
    ["Windtrace","2021-05-18",60],
    ["Windtrace","2021-05-19",60],
    ["Mihoyo Web Login","2021-05-20",20],
    ["Battlefront: Misty Dungeon","2021-05-21",140],
    ["Battlefront: Misty Dungeon","2021-05-23",140],
    ["Battlefront: Misty Dungeon","2021-05-25",140],
    ["Mimi Tomo","2021-05-27",60],
    ["1.6 Livestream Codes","2021-05-28",300],
    ["Mimi Tomo","2021-05-28",60],
    ["Mimi Tomo","2021-05-29",60],
    ["Mimi Tomo","2021-05-30",60],
    ["Mimi Tomo","2021-05-31",60],
    ["Mimi Tomo","2021-06-01",60],
    ["Mimi Tomo","2021-06-02",60],
    ["1.6 Patch Compensation","2021-06-08",600],
    ["Klee Trial","2021-06-08",20],
    ["Echoing Tales","2021-06-08",60],
    ["Midsummer Island Act 1","2021-06-08",150],
    ["Midsummer Island Act 2","2021-06-11",150],
    ["Echoing Tales","2021-06-11",300],
    ["Mihoyo Web Login","2021-06-13",20],
    ["Midsummer Island Act 3","2021-06-14",150],
    ["Midsummer Island Act 4","2021-06-17",150],
    ["Mihoyo Web Login","2021-06-20",20],
    ["Legend of the Vagabond Sword", "2021-06-25",60],
    ["Legend of the Vagabond Sword", "2021-06-26",60],
    ["Legend of the Vagabond Sword", "2021-06-27",60],
    ["Legend of the Vagabond Sword", "2021-06-28",60],
    ["Legend of the Vagabond Sword", "2021-06-29",60],
    ["Kazuha Trial","2021-06-29",20],
    ["Archon Quest Chapter 2 Pt 1","2021-06-29",60],
    ["Legend of the Vagabond Sword", "2021-06-30",60],
    ["Legend of the Vagabond Sword", "2021-07-01",60],
    ["Kaboomball Kombat", "2021-07-02", 120],
    ["Kaboomball Kombat", "2021-07-04", 180],
    ["Kaboomball Kombat", "2021-07-06", 120],
    ["Mihoyo Web Login","2021-07-06",20],
    ["2.0 Livestream Codes","2021-07-09",300],
    ["Never-Ending Battle", "2021-07-09", 60],
    ["Never-Ending Battle", "2021-07-10", 60],
    ["Never-Ending Battle", "2021-07-11", 60],
    ["Never-Ending Battle", "2021-07-12", 60],
    ["Never-Ending Battle", "2021-07-13", 60],
    ["Mihoyo Web Login","2021-07-13",20],
    ["Never-Ending Battle", "2021-07-14", 60],
    ["Never-Ending Battle", "2021-07-15", 60],
    ["Mihoyo Web Login","2021-07-20",20],
    ["2.0 Patch Compensation","2021-07-20",600],
    ["Ayaka Trial","2021-07-20",20],
    ["Thunder Sojourn","2021-07-22",150],
    ["Thunder Sojourn","2021-07-24",150],
    ["Thunder Sojourn","2021-07-27",150],
    ["Thunder Sojourn","2021-07-30",150],
    ["Mihoyo Web Login","2021-08-03",20],
    ["Lost Riches", "2021-08-06", 60],
    ["Lost Riches", "2021-08-07", 60],
    ["Lost Riches", "2021-08-08", 60],
    ["Lost Riches", "2021-08-09", 60],
    ["Lost Riches", "2021-08-10", 60],
    ["Yoimiya Trial","2021-08-10",20],
    ["Mihoyo Web Login","2021-08-10",20],
    ["Lost Riches", "2021-08-11", 60],
    ["Lost Riches", "2021-08-12", 60],
    ["Theater Mechanicus", "2021-08-13", 120],
    ["Theater Mechanicus", "2021-08-15", 120],
    ["Theater Mechanicus", "2021-08-17", 120],
    ["Mihoyo Web Login","2021-08-17",20],
    ["Theater Mechanicus", "2021-08-18", 60],
    ["2.1 Livestream Codes","2021-08-20",300],
    ["Phantom Flow","2021-08-31",420],
    ["2.1 Patch Compensation","2021-08-31",600],
    ["Raiden Trial","2021-08-31",20],
    ["Hyakunin Ikki","2021-09-02",70],
    ["Mihoyo Web Login","2021-09-03",20],
    ["Hyakunin Ikki","2021-09-03",70],
    ["Hyakunin Ikki","2021-09-04",70],
    ["Hyakunin Ikki","2021-09-05",70],
    ["Hyakunin Ikki","2021-09-06",70],
    ["Hyakunin Ikki","2021-09-07",70],
    ["Mihoyo Web Login","2021-09-10",20],
    ["Lunar Realm","2021-09-10",60],
    ["Lunar Realm","2021-09-11",60],
    ["Lunar Realm","2021-09-12",60],
    ["Lunar Realm","2021-09-13",60],
    ["Lunar Realm","2021-09-14",60],
    ["Lunar Realm","2021-09-15",60],
    ["Lunar Realm","2021-09-16",60],
    ["Mihoyo Web Login","2021-09-17",20],
    ["Spectral Secrets","2021-09-19",60],
    ["Spectral Secrets","2021-09-20",60],
    ["Spectral Secrets","2021-09-21",60],
    ["Kokomi Trial","2021-09-21",20],
    ["Spectral Secrets","2021-09-22",60],
    ["Spectral Secrets","2021-09-23",60],
    ["Spectral Secrets","2021-09-24",60],
    ["Spectral Secrets","2021-09-25",60],
    ["Moonchase","2021-09-27",360],
    ["Anni Daily Login","2021-09-28",160],
    ["Anni Daily Login","2021-09-30",320],
    ["Moonchase","2021-09-30",330],
    ["Anni Daily Login","2021-10-02",320],
    ["Anni Daily Login","2021-10-04",800],
    ["Moonchase","2021-10-04",360],
    ["2.2 Livestream Codes","2021-10-01",300],
    ["2.2 Patch Compensation","2021-10-12",600],
    ["Childe Trial","2021-10-12",20],
    ["2.2 Hangouts (Permanent)","2021-10-12",240],
    ["Tuned to the World's Sounds","2021-10-15",60],
    ["Tuned to the World's Sounds","2021-10-16",60],
    ["Tuned to the World's Sounds","2021-10-17",60],
    ["Mihoyo Web Login","2021-10-17",20],
    ["Tuned to the World's Sounds","2021-10-18",60],
    ["Tuned to the World's Sounds","2021-10-19",60],
    ["Tuned to the World's Sounds","2021-10-20",60],
    ["Tuned to the World's Sounds","2021-10-21",60],
    ["Labyrinth Warriors","2021-10-21",150],
    ["Labyrinth Warriors","2021-10-24",150],
    ["Labyrinth Warriors","2021-10-27",150],
    ["Labyrinth Warriors","2021-10-30",150],
    ["Hu Tao Trial","2021-11-02",20],
    ["Mihoyo Web Login","2021-11-03",20],
    ["Shadow of the Ancients","2021-11-05",120],
    ["Shadow of the Ancients","2021-11-07",120],
    ["Shadow of the Ancients","2021-11-09",180],
    ["Mihoyo Web Login","2021-11-10",20],
    ["2.3 Livestream Codes","2021-11-12",300],
    ["Dreams of Bloom","2021-11-20",420],
    ["2.3 Patch Compensation","2021-11-23",600],
    ["Eula/Albedo Trial","2021-11-23",40],
    ["2.3 Hangouts (Permanent)","2021-11-23",240],
    ["Shadows Amidst Snowstorms", "2021-11-25", 240],
    ["Shadows Amidst Snowstorms", "2021-11-28", 180],
    ["Shadows Amidst Snowstorms", "2021-12-01", 240],
    ["Mihoyo Web Login","2021-12-03",20],
    ["Shadows Amidst Snowstorms", "2021-12-04", 180],
    ["Playstation Award Celebration","2021-12-04",200],
    ["Playstation Award Celebration","2021-12-05",200],
    ["Playstation Award Celebration","2021-12-06",200],
    ["Playstation Award Celebration","2021-12-07",200],
    ["Shadows Amidst Snowstorms", "2021-12-07", 200],
    ["Bantan Sango Case Files", "2021-12-07", 120],
    ["Bantan Sango Case Files", "2021-12-09", 120],
    ["Mihoyo Web Login","2021-12-10",20],
    ["Mobile GOTY Award","2021-12-11",400],
    ["Bantan Sango Case Files", "2021-12-11", 120],
    ["Mobile GOTY Award","2021-12-12",400],
    ["Bantan Sango Case Files", "2021-12-13", 120],
    ["Mobile GOTY Award","2021-12-13",400],
    ["Mobile GOTY Award","2021-12-14",400],
    ["Itto Trial","2021-12-14",20],
    ["Itto Story Quest (Permanent)","2021-12-14",60],
    ["Mihoyo Web Login","2021-12-17",20],
    ["Misty Dungeon","2021-12-17",60],
    ["Misty Dungeon","2021-12-18",60],
    ["Misty Dungeon","2021-12-19",60],
    ["Misty Dungeon","2021-12-20",60],
    ["Misty Dungeon","2021-12-21",60],
    ["Misty Dungeon","2021-12-22",60],
    ["Misty Dungeon","2021-12-23",60],
    ["2.4 Livestream Codes","2021-12-24",300],
    ["Energy Amplifier","2021-12-24",140],
    ["Energy Amplifier","2021-12-26",140],
    ["Energy Amplifier","2021-12-28",140],
    ["Marvelous Merchandise","2021-12-27",40],
    ["Marvelous Merchandise","2021-12-28",40],
    ["Marvelous Merchandise","2021-12-29",40],
    ["Marvelous Merchandise","2021-12-30",40],
    ["Marvelous Merchandise","2021-12-31",140],
    ["Marvelous Merchandise","2022-1-01",40],
    ["Marvelous Merchandise","2022-1-02",40],
    ["Mihoyo Web Login","2022-01-03",20],
    ["2.4 Patch Compensation","2022-01-04",600],
    ["Xiao/Shenhe Trial","2022-01-04",40],
    ["2.4 Hangouts (Permanent)","2022-01-04",120],
    ["A Study in Potions","2022-01-07",140],
    ["A Study in Potions","2022-01-10",140],
    ["Mihoyo Web Login","2022-01-10",20],
    ["A Study in Potions","2022-01-13",140],
    ["Windtrace","2022-01-13",70],
    ["Windtrace","2022-01-14",70],
    ["Windtrace","2022-01-16",70],
    ["Windtrace","2022-01-17",70],
    ["Windtrace","2022-01-18",70],
    ["Windtrace","2022-01-19",70],
    ["Mihoyo Web Login","2022-01-17",20],
    ["Ganyu/Zhongli Trial","2022-01-25",40],
    ["Fleeting Colors in Flight","2022-01-25",200],
    ["May Fortune Find You","2022-01-25",160],
    ["Fleeting Colors in Flight","2022-01-27",200],
    ["May Fortune Find You","2022-01-27",320],
    ["May Fortune Find You","2022-01-29",320],
    ["May Fortune Find You","2022-01-31",800],
    ["Fleeting Colors in Flight","2022-01-31",200],
    ["Mihoyo Web Login","2022-02-03",20],
    ["2.5 Livestream Codes","2022-02-04",300],
    ["Eight Locales Over Mountains and Seas","2022-02-04",60],
    ["Eight Locales Over Mountains and Seas","2022-02-05",60],
    ["Eight Locales Over Mountains and Seas","2022-02-06",60],
    ["Eight Locales Over Mountains and Seas","2022-02-07",60],
    ["Eight Locales Over Mountains and Seas","2022-02-08",60],
    ["Eight Locales Over Mountains and Seas","2022-02-09",60],
    ["Flowing Lights and Colors","2022-02-09",160],
    ["Eight Locales Over Mountains and Seas","2022-02-10",60],
    ["Mihoyo Web Login","2022-02-10",20],
    ["Flowing Lights and Colors","2022-02-11",160],
    ["Flowing Lights and Colors","2022-02-13",160],
    ["2.5 Patch Compensation","2022-02-15",600],
    ["Yae Trial","2022-02-15",20],
    ["Mihoyo Web Login","2022-02-17",20],
    ["Three Realms Gateway Offering","2022-02-17",100],
    ["Three Realms Gateway Offering","2022-02-19",100],
    ["Three Realms Gateway Offering","2022-02-21",100],
    ["Divine Ingenuity","2022-03-02",140],
    ["Mihoyo Web Login","2022-03-03",20],
    ["Divine Ingenuity","2022-03-03",70],
    ["Divine Ingenuity","2022-03-04",70],
    ["Divine Ingenuity","2022-03-05",70],
    ["Divine Ingenuity","2022-03-06",70],
    ["Raiden/Kokomi Trial","2022-03-08",40],
    ["Mihoyo Web Login","2022-03-10",20],
    ["Of Drink A-Dreaming","2022-03-10",60],
    ["Of Drink A-Dreaming","2022-03-11",60],
    ["Of Drink A-Dreaming","2022-03-12",60],
    ["Of Drink A-Dreaming","2022-03-13",60],
    ["Of Drink A-Dreaming","2022-03-14",60],
    ["Of Drink A-Dreaming","2022-03-15",60],
    ["Of Drink A-Dreaming","2022-03-16",60],
    ["Mihoyo Web Login","2022-03-17",20],
    ["2.6 Livestream Codes","2022-03-18",300],
    ["Hyakunin Ikki","2022-03-18",70],
    ["Hyakunin Ikki","2022-03-19",70],
    ["Hyakunin Ikki","2022-03-20",70],
    ["Hyakunin Ikki","2022-03-21",70],
    ["Hyakunin Ikki","2022-03-22",70],
    ["Hyakunin Ikki","2022-03-23",70],
    ["2.6 Patch Compensation","2022-03-29",600],
    ["Ayato/Venti Trial","2022-03-29",40],
    ["Outside the Canvas Inside the Lens","2022-04-01",60],
    ["Outside the Canvas Inside the Lens","2022-04-02",60],
    ["Outside the Canvas Inside the Lens","2022-04-03",60],
    ["Mihoyo Web Login","2022-04-03",20],
    ["Outside the Canvas Inside the Lens","2022-04-04",60],
    ["Outside the Canvas Inside the Lens","2022-04-05",60],
    ["Outside the Canvas Inside the Lens","2022-04-06",60],
    ["Outside the Canvas Inside the Lens","2022-04-07",60],
    ["True Tales of the Violet Garden","2022-04-07",120],
    ["True Tales of the Violet Garden","2022-04-08",40],
    ["True Tales of the Violet Garden","2022-04-09",180],
    ["Mihoyo Web Login","2022-04-10",20],
    ["True Tales of the Violet Garden","2022-04-10",60],
    ["True Tales of the Violet Garden","2022-04-11",220],
    ["True Tales of the Violet Garden","2022-04-12",140],
    ["True Tales of the Violet Garden","2022-04-13",160],
    ["True Tales of the Violet Garden","2022-04-14",80],
    ["Mihoyo Web Login","2022-04-17",20],
    ["Ayaka Trial","2022-04-19",20],
    ["Vibro Crystal Research","2022-04-21",70],
    ["Vibro Crystal Research","2022-04-22",70],
    ["Vibro Crystal Research","2022-04-23",70],
    ["Vibro Crystal Research","2022-04-24",70],
    ["Vibro Crystal Research","2022-04-25",70],
    ["Vibro Crystal Research","2022-04-26",70],
    ["Mihoyo Web Login","2022-05-03",20],
    ["Marvelous Merchandise","2022-05-06",40],
    ["Marvelous Merchandise","2022-05-07",40],
    ["Marvelous Merchandise","2022-05-08",40],
    ["Marvelous Merchandise","2022-05-09",40],
    ["Marvelous Merchandise","2022-05-10",140],
    ["Mihoyo Web Login","2022-05-10",20],
    ["Delay Compensation","2022-05-11",400],
    ["Marvelous Merchandise","2022-05-11",40],
    ["Marvelous Merchandise","2022-05-12",40],
    ["Spices from the West","2022-05-14",60],
    ["Spices from the West","2022-05-15",60],
    ["Spices from the West","2022-05-16",60],
    ["Mihoyo Web Login","2022-04-17",20],
    ["Spices from the West","2022-05-17",60],
    ["Spices from the West","2022-05-18",60],
    ["Delay Compensation","2022-05-18",400],
    ["Spices from the West","2022-05-19",60],
    ["Spices from the West","2022-05-20",60],
    ["2.7 Livestream Codes","2022-05-20",300],
    ["Delay Compensation","2022-05-25",400],
    ["2.7 Patch Compensation","2022-05-30",600],
    ["Yelan/Xiao Trial","2022-05-30",40],
    ["Yelan Story Quest","2022-05-30",60],
    ["Perilous Trail","2022-05-30",240],
    ["Perilous Trail","2022-06-01",240],
    ["Perilous Trail","2022-06-02",240],
    ["Perilous Trail","2022-06-03",240],
    ["Mihoyo Web Login","2022-06-03",20],
    ["Mihoyo Web Login","2022-06-10",20],
    ["Glorious Drumalong Festival","2022-06-13",60],
    ["Glorious Drumalong Festival","2022-06-14",60],
    ["Glorious Drumalong Festival","2022-06-15",60],
    ["Glorious Drumalong Festival","2022-06-16",60],
    ["Glorious Drumalong Festival","2022-06-17",60],
    ["Mihoyo Web Login","2022-06-17",20],
    ["Glorious Drumalong Festival","2022-06-18",60],
    ["Glorious Drumalong Festival","2022-06-19",60],
    ["Itto Trial","2022-06-21",20],
    ["Kuki Hangout","2022-06-21",60],
    ["A Muddy Bizarre Adventure","2022-06-22",80],
    ["A Muddy Bizarre Adventure","2022-06-23",80],
    ["A Muddy Bizarre Adventure","2022-06-24",80],
    ["A Muddy Bizarre Adventure","2022-06-25",80],
    ["A Muddy Bizarre Adventure","2022-06-26",100],
    ["Core of the Apparatus","2022-06-29",60],
    ["Core of the Apparatus","2022-06-30",60],
    ["Core of the Apparatus","2022-07-01",60],
    ["2.8 Livestream Codes","2022-07-02",300],
    ["Core of the Apparatus","2022-07-02",60],
    ["Core of the Apparatus","2022-07-03",60],
    ["Mihoyo Web Login","2022-07-03",20],
    ["Core of the Apparatus","2022-07-04",60],
    ["Core of the Apparatus","2022-07-05",60],
    ["Mihoyo Web Login","2022-07-10",20],
    ["2.8 Patch Compensation","2022-07-12",600],
    ["Klee/Kazuha Trial","2022-07-12",40],
    ["Heizou Hangout","2022-07-12",60],
    ["Kazuha Story","2022-07-12",60],
    ["Summertime Odyssey","2022-07-15",200],
    ["Summertime Odyssey","2022-07-16",170],
    ["Mihoyo Web Login","2022-07-17",20],
    ["Summertime Odyssey","2022-07-17",170],
    ["Summertime Odyssey","2022-07-18",170],
    ["Summertime Odyssey","2022-07-19",200],
    ["Hidden Strife","2022-07-27",60],
    ["Hidden Strife","2022-07-28",60],
    ["Hidden Strife","2022-07-29",60],
    ["Hidden Strife","2022-07-30",60],
    ["Hidden Strife","2022-07-31",60],
    ["Hidden Strife","2022-08-01",60],
    ["Hidden Strife","2022-08-02",60],
    ["Yoimiya Trial","2022-08-02",20],
    ["Mihoyo Web Login","2022-08-03",20],
    ["Reminiscent Regimen","2022-08-04",70],
    ["Reminiscent Regimen","2022-08-05",70],
    ["Reminiscent Regimen","2022-08-06",70],
    ["Reminiscent Regimen","2022-08-07",70],
    ["Reminiscent Regimen","2022-08-08",70],
    ["Reminiscent Regimen","2022-08-09",70],
    ["Mihoyo Web Login","2022-08-10",20],
    ["Evermotion Mechanical Painting","2022-08-12",90],
    ["2.8 Livestream Codes","2022-08-13",300],
    ["Evermotion Mechanical Painting","2022-08-13",60],
    ["Evermotion Mechanical Painting","2022-08-14",60],
    ["Evermotion Mechanical Painting","2022-08-15",60],
    ["Evermotion Mechanical Painting","2022-08-16",60],
    ["Evermotion Mechanical Painting","2022-08-17",90],
    ["Mihoyo Web Login","2022-08-17",20],
    ["3.0 Patch Compensation","2022-08-23",600],
    ["Tighnari/Zhongli Trial","2022-08-23",40],
    ["Chapter 3 Archon Quest 1/2","2022-08-23",120],
    ["Tighnari Story Quest","2022-08-24",60],
    ["Graven Innocence","2022-08-24",360],
    ["Graven Innocence","2022-08-25",120],
    ["Graven Innocence","2022-08-26",40],
    ["Graven Innocence","2022-08-27",200],
    ["Graven Innocence","2022-08-28",40],
    ["Graven Innocence","2022-08-29",40],
    ["Graven Innocence","2022-08-30",220],
    ["Graven Innocence","2022-09-02",40],
    ["Mihoyo Web Login","2022-09-03",20],
    ["Fayze Trials","2022-09-03",420],
    ["Mihoyo Web Login","2022-09-10",20],
    ["Tablet Analytics","2022-09-10",420],
    ["Ganyu/Kokomi Trial","2022-09-13",40],
    ["3.1 Livestream Codes","2022-09-16",300],
    ["Mihoyo Web Login","2022-09-17",20],
    ["Lost Riches","2022-09-17",420],
    ["3.1 Patch Compensation","2022-09-27",600],
    ["Cyno/Venti Trial","2022-09-27",40],
    ["Chapter 3 Archon Quest 3/4","2022-09-27",120],
    ["Anniversary Reward","2022-09-27",400],
    ["Anniversary Reward","2022-09-28",400],
    ["Cyno Story Quest","2022-09-28",60],
    ["Anniversary Reward","2022-09-29",400],
    ["Of Ballad and Brews","2022-09-29",300],
    ["Mihoyo Web Login","2022-09-29",20],
    ["Anniversary Reward","2022-09-30",400],
    ["Mihoyo Web Login","2022-10-01",20],
    ["Of Ballad and Brews","2022-10-02",300],
    ["Mihoyo Web Login","2022-10-03",20],
    ["Mihoyo Web Login","2022-10-03",20],
    ["Of Ballad and Brews","2022-10-05",400],
    ["Mihoyo Web Login","2022-10-10",20],
    ["Hyakunin Ikki","2022-10-10",70],
    ["Hyakunin Ikki","2022-10-11",70],
    ["Hyakunin Ikki","2022-10-12",70],
    ["Hyakunin Ikki","2022-10-13",70],
    ["Hyakunin Ikki","2022-10-14",70],
    ["Nilou/Albedo Trial","2022-10-14",40],
    ["Path of Gleaming Jade","2022-10-14",160],
    ["Nilou Story Quest","2022-10-14",60],
    ["Hyakunin Ikki","2022-10-15",70],
    ["Path of Gleaming Jade","2022-10-16",320],
    ["Mihoyo Web Login","2022-10-17",20],
    ["Wind Chaser","2022-10-17",420],
    ["Path of Gleaming Jade","2022-10-18",320],
    ["Path of Gleaming Jade","2022-10-20",800],
    ["3.2 Livestream","2022-10-21",300],
    ["Star-Seeker's Sojourn","2022-10-24",420],
    ["3.2 Patch Compensation","2022-11-01",600],
    ["Nahida/Yoimiya Trial","2022-11-01",40],
    ["Chapter 3 Archon Quest 5","2022-11-02",90],
    ["Nahida Story Quest","2022-11-03",60],
    ["Mihoyo Web Login","2022-11-03",20],
    ["Adventurer's Trial","2022-11-04",60],
    ["Adventurer's Trial","2022-11-05",60],
    ["Adventurer's Trial","2022-11-06",60],
    ["Adventurer's Trial","2022-11-07",60],
    ["Adventurer's Trial","2022-11-08",180],
    ["Fabulous Fungus","2022-11-10",330],
    ["Mihoyo Web Login","2022-11-10",20],
    ["Fabulous Fungus","2022-11-11",180],
    ["Fabulous Fungus","2022-11-12",180],
    ["Fabulous Fungus","2022-11-13",180],
    ["Fabulous Fungus","2022-11-14",60],
    ["Mihoyo Web Login","2022-11-17",20],
    ["Hypostasis Symphony","2022-11-17",60],
    ["Hypostasis Symphony","2022-11-18",60],
    ["Yae/Tartaglia Trial","2022-11-18",40],
    ["Hypostasis Symphony","2022-11-19",60],
    ["Hypostasis Symphony","2022-11-20",60],
    ["Hypostasis Symphony","2022-11-21",60],
    ["Hypostasis Symphony","2022-11-22",60],
    ["Hypostasis Symphony","2022-11-23",60],
    ["Outside the Canvas, Inside the Lens: Greenery Chapter","2022-11-24",60],
    ["3.3 Livestream","2022-11-25",300],
    ["Outside the Canvas, Inside the Lens: Greenery Chapter","2022-11-25",60],
    ["Outside the Canvas, Inside the Lens: Greenery Chapter","2022-11-26",60],
    ["Outside the Canvas, Inside the Lens: Greenery Chapter","2022-11-27",60],
    ["Outside the Canvas, Inside the Lens: Greenery Chapter","2022-11-28",60],
    ["Outside the Canvas, Inside the Lens: Greenery Chapter","2022-11-29",60],
    ["Outside the Canvas, Inside the Lens: Greenery Chapter","2022-11-30",60],
    ["Marvelous Merchandise","2022-11-25",40],
    ["Marvelous Merchandise","2022-11-26",40],
    ["Marvelous Merchandise","2022-11-27",40],
    ["Marvelous Merchandise","2022-11-28",40],
    ["Marvelous Merchandise","2022-11-29",140],
    ["Marvelous Merchandise","2022-11-30",40],
    ["Marvelous Merchandise","2022-12-01",40],
    ["Mihoyo Web Login","2022-12-03",20],
    ["Playstaion Partner Award","2022-12-03",200],
    ["Playstaion Partner Award","2022-12-04",200],
    ["Playstaion Partner Award","2022-12-05",200],
    ["Playstaion Partner Award","2022-12-06",200],
    ["3.3 Patch Compensation","2022-12-06",600],
    ["Wanderer/Itto Trial","2022-12-06",40],
    ["Chapter 3 Archon Interlude Quest","2022-12-07",60],
    ["Misty Dungeon: Realm of Sand","2022-12-09",120],
    ["Mihoyo Web Login","2022-12-10",20],
    ["The Game Awards Award","2022-12-10",200],
    ["Misty Dungeon: Realm of Sand","2022-12-11",120],
    ["The Game Awards Award","2022-12-11",200],
    ["The Game Awards Award","2022-12-12",200],
    ["The Game Awards Award","2022-12-13",200],
    ["Misty Dungeon: Realm of Sand","2022-12-13",180],
    ["Akitsu Kimodameshi","2022-12-15",330],
    ["Akitsu Kimodameshi","2022-12-17",330],
    ["Akitsu Kimodameshi","2022-12-19",330],
    ["Mihoyo Web Login","2022-12-17",20],
    ["Raiden/Ayato Trial","2022-12-27",40],
    ["Windtrace","2022-12-28",120],
    ["Windtrace","2022-12-29",60],
    ["Windtrace","2022-12-30",60],
    ["Windtrace","2022-12-31",60],
    ["Windtrace","2023-01-01",60],
    ["Windtrace","2023-01-02",60],
    ["Mihoyo Web Login","2023-01-03",20],
    ["Across the Wilderness","2023-01-03",100],
    ["Across the Wilderness","2023-01-04",80],
    ["Across the Wilderness","2023-01-05",80],
    ["3.4 Livestream","2023-01-06",300],
    ["Across the Wilderness","2023-01-06",80],
    ["Across the Wilderness","2023-01-07",80],
    ["Mihoyo Web Login","2023-01-03",20],
    ["Mihoyo Web Login","2023-01-10",20],
    ["Mihoyo Web Login","2023-01-17",20],
    ["3.4 Patch Compensation","2023-01-17",600],
    ["AlHaitham/Xiao Trial","2023-01-17",40],
    ["AlHaitham Story Quest","2023-01-17",60],
    ["May Fortune Find You","2023-01-19",160],
    ["The Exquisite Night Chimes","2023-01-19",270],
    ["Mihoyo Web Login","2023-01-19",20],
    ["May Fortune Find You","2023-01-21",320],
    ["The Exquisite Night Chimes","2023-01-21",230],
    ["Mihoyo Web Login","2023-01-21",20],
    ["May Fortune Find You","2023-01-23",320],
    ["The Exquisite Night Chimes","2023-01-23",210],
    ["Mihoyo Web Login","2023-01-23",20],
    ["May Fortune Find You","2023-01-25",800],
    ["The Exquisite Night Chimes","2023-01-25",240],
    ["Second Blooming","2023-01-31",80],
    ["Second Blooming","2023-02-01",80],
    ["Second Blooming","2023-02-02",80],
    ["Second Blooming","2023-02-03",80],
    ["Mihoyo Web Login","2023-02-03",20],
    ["Second Blooming","2023-02-04",100],
    ["Iridescent Splendor","2023-02-05",160],
    ["HuTao/Yelan Trial","2023-02-07",40],
    ["Iridescent Splendor","2023-02-07",160],
    ["Iridescent Splendor","2023-02-09",160],
    ["Warrior's Spirit","2023-02-09",70],
    ["Mihoyo Web Login","2023-02-10",20],
    ["Warrior's Spirit","2023-02-10",70],
    ["Warrior's Spirit","2023-02-11",70],
    ["Warrior's Spirit","2023-02-12",70],
    ["Warrior's Spirit","2023-02-13",70],
    ["Warrior's Spirit","2023-02-14",70],
    ["Beetle Brawl","2023-02-16",80],
    ["Beetle Brawl","2023-02-17",80],
    ["Mihoyo Web Login","2023-02-17",20],
    ["3.5 Livestream","2023-02-17",300],
    ["Beetle Brawl","2023-02-18",80],
    ["Beetle Brawl","2023-02-19",80],
    ["Beetle Brawl","2023-02-20",100],
    ["3.5 Patch Compensation","2023-02-28",600],
    ["Dehya/Cyno Trial","2023-02-28",40],
    ["Dehya Story Quest","2023-03-01",60],
    ["Archon Quest Chapter III: Act VI - Caribert","2023-03-02",245],
    ["Faruzan Hangout","2023-03-03",60],
    ["Mihoyo Web Login","2023-03-03",20],
    ["Windblume's Breath","2023-03-03",250],
    ["Windblume's Breath","2023-03-04",100],
    ["Windblume's Breath","2023-03-05",250],
    ["Windblume's Breath","2023-03-06",100],
    ["Windblume's Breath","2023-03-07",250],
    ["Mihoyo Web Login","2023-03-10",20],
    ["Vibro-Crystal Verification","2023-03-14",70],
    ["Vibro-Crystal Verification","2023-03-15",70],
    ["Vibro-Crystal Verification","2023-03-16",70],
    ["Vibro-Crystal Verification","2023-03-17",70],
    ["Mihoyo Web Login","2023-03-17",20],
    ["Vibro-Crystal Verification","2023-03-18",70],
    ["Vibro-Crystal Verification","2023-03-19",70],
    ["Ayaka/Shenhe Trial","2023-03-21",40],
    ["Fungus Mechanicus","2023-03-21",70],
    ["Fungus Mechanicus","2023-03-22",50],
    ["Fungus Mechanicus","2023-03-23",50],
    ["Fungus Mechanicus","2023-03-24",50],
    ["Fungus Mechanicus","2023-03-25",50],
    ["Fungus Mechanicus","2023-03-26",50],
    ["Fungus Mechanicus","2023-03-27",50],
    ["Fungus Mechanicus","2023-03-27",70],
    ["3.6 Livestream Codes","2023-03-31",300],
    ["Spices from the West: Northerly Search","2023-03-31",60],
    ["Spices from the West: Northerly Search","2023-04-01",60],
    ["Spices from the West: Northerly Search","2023-04-02",60],
    ["Spices from the West: Northerly Search","2023-04-03",60],
    ["Mihoyo Web Login","2023-04-03",20],
    ["Spices from the West: Northerly Search","2023-04-04",60],
    ["Spices from the West: Northerly Search","2023-04-05",60],
    ["Spices from the West: Northerly Search","2023-04-06",60],
    ["Mihoyo Web Login","2023-04-10",20],
    ["3.6 Patch Compensation","2023-04-11",600],
    ["Nilou/Nahida Trial","2023-04-11",40],
    ["Nahida Story Quest 2","2023-04-12",60],
    ["Brewing Developments","2023-04-13",120],
    ["Brewing Developments","2023-04-15",90],
    ["Mihoyo Web Login","2023-04-17",20],
    ["Brewing Developments","2023-04-17",90],
    ["Brewing Developments","2023-04-19",120],
    ["Fulminating Sandstorm","2023-04-21",100],
    ["Fulminating Sandstorm","2023-04-22",80],
    ["Fulminating Sandstorm","2023-04-23",80],
    ["Fulminating Sandstorm","2023-04-24",80],
    ["Fulminating Sandstorm","2023-04-25",80],
    ["A Parade of Providence","2023-04-27",250],
    ["A Parade of Providence","2023-04-29",250],
    ["A Parade of Providence","2023-05-01",250],
    ["Baizhu/Ganyu Trial","2023-05-02",40],
    ["A Parade of Providence","2023-05-03",250],
    ["Mihoyo Web Login","2023-05-03",20],
    ["The Recollector's Path","2023-05-08",70],
    ["The Recollector's Path","2023-05-09",70],
    ["Mihoyo Web Login","2023-05-10",20],
    ["The Recollector's Path","2023-05-10",70],
    ["The Recollector's Path","2023-05-11",70],
    ["3.7 Livestream Codes","2023-05-12",300],
    ["The Recollector's Path","2023-05-12",70],
    ["The Recollector's Path","2023-05-13",70],
    ["Mihoyo Web Login","2023-05-17",20],
    ["3.7 Patch Compensation","2023-05-23",600],
    ["Yoimiya/Yae Trial","2023-05-23",40],
    ["Yoimiya Story Quest 2","2023-05-24",60],
    ["Kaveh Hangout","2023-05-24",60],
    ["Duel! The Summoners Summit","2023-05-25",250],
    ["Duel! The Summoners Summit","2023-05-27",250],
    ["Duel! The Summoners Summit","2023-05-29",250],
    ["Duel! The Summoners Summit","2023-05-31",250],
    ["Mihoyo Web Login","2023-06-03",20],
    ["Divine Ingenuity","2023-06-08",100],
    ["Divine Ingenuity","2023-06-09",80],
    ["Divine Ingenuity","2023-06-10",80],
    ["Mihoyo Web Login","2023-06-10",80],
    ["Divine Ingenuity","2023-06-11",80],
    ["Alhaitham/Kazuha Trial","2023-06-13",40],
    ["Feast of the Departed Warriors","2023-06-14",105],
    ["Feast of the Departed Warriors","2023-06-16",105],
    ["Mihoyo Web Login","2023-06-17",20],
    ["Feast of the Departed Warriors","2023-06-18",105],
    ["Feast of the Departed Warriors","2023-06-20",105],
    ["Fayz Trials: Hypothesis","2023-06-21",60],
    ["Fayz Trials: Hypothesis","2023-06-22",60],
    ["3.8 Livestream Codes","2023-06-23",300],
    ["Fayz Trials: Hypothesis","2023-06-23",60],
    ["Fayz Trials: Hypothesis","2023-06-24",60],
    ["Fayz Trials: Hypothesis","2023-06-25",60],
    ["Fayz Trials: Hypothesis","2023-06-26",60],
    ["Fayz Trials: Hypothesis","2023-06-27",60],
    ["Mihoyo Web Login","2023-07-03",20],
    ["3.8 Patch Compensation","2023-07-04",600],
    ["Klee/Eula Trial","2023-07-04",40],
    ["Kaeya Hangout","2023-07-05",60],
    ["Secret Summer Paradise","2023-07-04",90],
    ["Secret Summer Paradise","2023-07-05",30],
    ["Secret Summer Paradise","2023-07-06",30],
    ["Secret Summer Paradise","2023-07-07",220],
    ["Secret Summer Paradise","2023-07-08",30],
    ["Secret Summer Paradise","2023-07-09",220],
    ["Mihoyo Web Login","2023-07-10",20],
    ["Secret Summer Paradise","2023-07-11",260],
    ["Mihoyo Web Login","2023-07-17",20],
    ["Adventurer's Trials: Advanced","2023-07-20",90],
    ["Adventurer's Trials: Advanced","2023-07-21",90],
    ["Adventurer's Trials: Advanced","2023-07-22",90],
    ["Adventurer's Trials: Advanced","2023-07-23",90],
    ["Adventurer's Trials: Advanced","2023-07-24",60],
    ["Kokomi/Wanderer Trial","2023-07-25",40],
    ["Perilous Expedition","2023-07-26",100],
    ["Perilous Expedition","2023-07-27",80],
    ["Perilous Expedition","2023-07-28",80],
    ["Perilous Expedition","2023-07-29",80],
    ["Perilous Expedition","2023-07-30",80],
    ["Shared Sight","2023-08-02",70],
    ["Shared Sight","2023-08-03",70],
    ["Mihoyo Web Login","2023-08-03",20],
    ["Shared Sight","2023-08-04",70],
    ["4.0 Livestream Codes","2023-08-04",300],
    ["Shared Sight","2023-08-05",70],
    ["Shared Sight","2023-08-06",70],
    ["Shared Sight","2023-08-07",70],
    ["Mihoyo Web Login","2023-08-10",20],
    ["4.0 Patch Compensation","2023-08-15",600],
    ["Lyney/Yelan Trial","2023-08-15",40],
    ["Archon Quest Act 4 Ch 1","2023-08-15",220],
    ["Archon Quest Act 4 Ch 2","2023-08-15",220],
    ["Lyney Story Quest","2023-08-15",60],
    ["Relic Records: Creations of the Hydro Nation","2023-08-15",75],
    ["Relic Records: Creations of the Hydro Nation","2023-08-15",75],
    ["Mihoyo Web Login","2023-08-17",20],
    ["Relic Records: Creations of the Hydro Nation","2023-08-15",75],
    ["Relic Records: Creations of the Hydro Nation","2023-08-15",75],
    ["Relic Records: Creations of the Hydro Nation","2023-08-15",60],
    ["Relic Records: Creations of the Hydro Nation","2023-08-15",60],
    ["Mega Meka Melee Shop","2023-08-24",100],
    ["Mega Meka Melee","2023-08-24",300],
    ["Mega Meka Melee","2023-08-26",300],
    ["Mega Meka Melee","2023-08-28",300],
    ["Relic Records: Creations of the Hydro Nation","2023-08-28",0],
    ["Mihoyo Web Login","2023-09-03",20],
    ["Verdict of Blades","2023-09-04",70],
    ["Zhongli/Childe Trial","2023-09-05",40],
    ["Verdict of Blades","2023-09-05",70],
    ["Verdict of Blades","2023-09-06",70],
    ["Verdict of Blades","2023-09-07",70],
    ["Verdict of Blades","2023-09-08",70],
    ["Verdict of Blades","2023-09-09",70],
    ["Mihoyo Web Login","2023-09-10",20],
    ["Mega Meka Melee","2023-09-11",0],
    ["Mega Meka Melee Shop","2023-09-11",0],
    ["Studies in Light and Shadow: A Fontaine of Enchantment","2023-09-14",70],
    ["Studies in Light and Shadow: A Fontaine of Enchantment","2023-09-15",70],
    ["4.1 Livestream Codes","2023-09-15",300],
    ["Studies in Light and Shadow: A Fontaine of Enchantment","2023-09-16",70],
    ["Studies in Light and Shadow: A Fontaine of Enchantment","2023-09-17",70],
    ["Mihoyo Web Login","2023-09-17",20],
    ["Verdict of Blades","2023-09-18",0],
    ["Studies in Light and Shadow: A Fontaine of Enchantment","2023-09-18",70],
    ["Studies in Light and Shadow: A Fontaine of Enchantment","2023-09-19",70],
    ["Studies in Light and Shadow: A Fontaine of Enchantment","2023-09-25",0],
    ["4.1 Patch Compensation","2023-09-26",600],
    ["Neuvillete/Hu Tao Trial","2023-09-26",40],
    ["Archon Quest Act 4 Ch 3","2023-09-26",220],
    ["Archon Quest Act 4 Ch 4","2023-09-26",220],
    ["Neuvillete Story Quest","2023-09-26",60],
    ["Treasures Along the Road","2023-09-28",400],
    ["Radiant Harvest","2023-09-28",60],
    ["Treasures Along the Road","2023-09-29",400],
    ["Radiant Harvest","2023-09-29",60],
    ["Bathing in Flowing Moonlight","2023-09-29",160],
    ["Treasures Along the Road","2023-09-30",400],
    ["Radiant Harvest","2023-09-30",60],
    ["Treasures Along the Road","2023-10-01",400],
    ["Bathing in Flowing Moonlight","2023-10-01",320],
    ["Radiant Harvest","2023-10-01",60],
    ["Radiant Harvest","2023-10-02",60],
    ["Bathing in Flowing Moonlight","2023-10-03",320],
    ["Mihoyo Web Login","2023-10-03",20],
    ["Radiant Harvest","2023-10-03",60],
    ["Radiant Harvest","2023-10-04",60],
    ["Bathing in Flowing Moonlight","2023-10-05",800],
    ["Dodoco's Bomb-tastic Adventure","2023-10-06",70],
    ["Dodoco's Bomb-tastic Adventure","2023-10-07",70],
    ["Dodoco's Bomb-tastic Adventure","2023-10-08",70],
    ["Dodoco's Bomb-tastic Adventure","2023-10-09",70],
    ["Radiant Harvest","2023-10-09",0],
    ["Dodoco's Bomb-tastic Adventure","2023-10-10",70],
    ["Mihoyo Web Login","2023-10-10",20],
    ["Dodoco's Bomb-tastic Adventure","2023-10-11",70],
    ["Waterborne Poetry","2023-10-12",240],
    ["Waterborne Poetry","2023-10-14",240],
    ["Waterborne Poetry","2023-10-16",240],
    ["Dodoco's Bomb-tastic Adventure","2023-10-16",0],
    ["Wriothesley/Venti Trial","2023-10-17",40],
    ["Mihoyo Web Login","2023-10-17",20],
    ["Waterborne Poetry","2023-10-18",270],
    ["The Peaks and Troughs of Life","2023-10-23",100],
    ["The Peaks and Troughs of Life","2023-10-24",80],
    ["The Peaks and Troughs of Life","2023-10-25",80],
    ["4.2 Livestream Codes","2023-10-27",300],
    ["4.2 Livestream Codes","2023-10-28",0],
    ["The Peaks and Troughs of Life","2023-10-26",80],
    ["The Peaks and Troughs of Life","2023-10-27",80],
    ["Waterborne Poetry","2023-10-30",0],
    ["Mihoyo Web Login","2023-11-03",20],
    ["4.2 Patch Compensation","2023-11-07",600],
    ["Furina/Baizhu Trial","2023-11-07",40],
    ["Archon Quest Act 4 Ch 5","2023-11-07",220],
    ["Furina Story Quest","2023-11-07",60],
    ["Misty Dungeon: Realm of Water","2023-11-08",60],
    ["Misty Dungeon: Realm of Water","2023-11-09",60],
    ["Mihoyo Web Login","2023-11-10",20],
    ["Misty Dungeon: Realm of Water","2023-11-10",60],
    ["Misty Dungeon: Realm of Water","2023-11-11",60],
    ["Misty Dungeon: Realm of Water","2023-11-12",60],
    ["Misty Dungeon: Realm of Water","2023-11-13",60],
    ["Misty Dungeon: Realm of Water","2023-11-14",60],
    ["Mihoyo Web Login","2023-11-17",20],
    ["Graph Adversarial Technology Experiment Log","2023-11-17",60],
    ["Graph Adversarial Technology Experiment Log","2023-11-18",60],
    ["Graph Adversarial Technology Experiment Log","2023-11-19",60],
    ["Graph Adversarial Technology Experiment Log","2023-11-20",60],
    ["Graph Adversarial Technology Experiment Log","2023-11-21",60],
    ["Graph Adversarial Technology Experiment Log","2023-11-22",60],
    ["Graph Adversarial Technology Experiment Log","2023-11-23",60],
    ["Thelxie's Fantastic Adventures","2023-11-23",240],
    ["Thelxie's Fantastic Adventures","2023-11-24",160],
    ["Thelxie's Fantastic Adventures","2023-11-25",310],
    ["Thelxie's Fantastic Adventures","2023-11-26",200],
    ["Thelxie's Fantastic Adventures","2023-11-27",90],
    ["Cyno/Ayato Trial","2023-11-28",40],
    ["Mihoyo Web Login","2023-12-03",20],
    ["Lil Fungi's Fun-Tastic Fiesta","2023-12-04",70],
    ["Lil Fungi's Fun-Tastic Fiesta","2023-12-05",70],
    ["Lil Fungi's Fun-Tastic Fiesta","2023-12-06",70],
    ["Lil Fungi's Fun-Tastic Fiesta","2023-12-07",70],
    ["4.3 Livestream Codes","2023-12-08",300],
    ["Lil Fungi's Fun-Tastic Fiesta","2023-12-08",70],
    ["4.3 Livestream Codes","2023-12-09",0],
    ["Lil Fungi's Fun-Tastic Fiesta","2023-12-09",70],
    ["Mihoyo Web Login","2023-12-10",20],
    ["Thelxie's Fantastic Adventures","2023-12-11",0],
    ["Mihoyo Web Login","2023-12-17",20],
    ["4.3 Patch Compensation","2023-12-19",600],
    ["Navia/Ayaka Trial","2023-12-19",40],
    ["Navia Story Quest","2023-12-19",60],
    ["Roses and Muskets","2023-12-21",150],
    ["Roses and Muskets","2023-12-22",120],
    ["Roses and Muskets","2023-12-23",210],
    ["Roses and Muskets","2023-12-24",120],
    ["Roses and Muskets","2023-12-25",190],
    ["Roses and Muskets","2023-12-26",120],
    ["Roses and Muskets","2023-12-27",90],
    ["Lost Riches","2024-01-02",60],
    ["Lost Riches","2024-01-03",60],
    ["Mihoyo Web Login","2024-01-03",20],
    ["Lost Riches","2024-01-04",60],
    ["Lost Riches","2024-01-05",60],
    ["Lost Riches","2024-01-06",60],
    ["Lost Riches","2024-01-07",60],
    ["Lost Riches","2024-01-08",60],
    ["Roses and Muskets","2024-01-08",0],
    ["Raiden/Yoimiya Trial","2024-01-09",40],
    ["Mihoyo Web Login","2024-01-10",20],
    ["Dance of Resolute Will","2024-01-10",100],
    ["Dance of Resolute Will","2024-01-11",80],
    ["Dance of Resolute Will","2024-01-12",80],
    ["Dance of Resolute Will","2024-01-13",80],
    ["Dance of Resolute Will","2024-01-14",80],
    ["Lost Riches","2024-01-15",0],
    ["Mihoyo Web Login","2024-01-17",20],
    ["Arataki Blazing Armor Beetle Battle Boot Camp","2024-01-17",100],
    ["Arataki Blazing Armor Beetle Battle Boot Camp","2024-01-18",80],
    ["4.3 Livestream Codes","2024-01-19",300],
    ["Arataki Blazing Armor Beetle Battle Boot Camp","2024-01-19",80],
    ["4.3 Livestream Codes","2024-01-20",0],
    ["Arataki Blazing Armor Beetle Battle Boot Camp","2024-01-20",80],
    ["Arataki Blazing Armor Beetle Battle Boot Camp","2024-01-21",80],
    ["Marvelous Merchandise","2024-01-22",40],
    ["Marvelous Merchandise","2024-01-23",40],
    ["Marvelous Merchandise","2024-01-24",40],
    ["Marvelous Merchandise","2024-01-25",40],
    ["Marvelous Merchandise","2024-01-26",140],
    ["Marvelous Merchandise","2024-01-27",40],
    ["Marvelous Merchandise","2024-01-28",40],
    ["4.4 Patch Compensation","2024-01-30",600],
    ["Xianyun/Nahida Trial","2024-01-30",40],
    ["Xianyun Story Quest","2024-01-30",60],
    ["Mihoyo Web Login","2024-02-03",20],
    ["May Fortune Find You","2024-02-03",160],
    ["May Fortune Find You","2024-02-05",320],
    ["Vibrant Harriers Aloft In Spring Breeze","2024-02-05",280],
    ["May Fortune Find You","2024-02-07",320],
    ["Vibrant Harriers Aloft In Spring Breeze","2024-02-07",330],
    ["May Fortune Find You","2024-02-09",800],
    ["Vibrant Harriers Aloft In Spring Breeze","2024-02-09",310],
    ["Vibrant Harriers Aloft In Spring Breeze","2024-02-11",80],
    ["Mihoyo Web Login","2024-02-10",20],
    ["Triumphant Frenzy","2024-02-15",100],
    ["Triumphant Frenzy","2024-02-16",80],
    ["Mihoyo Web Login","2024-02-17",20],
    ["Triumphant Frenzy","2024-02-17",80],
    ["May Fortune Find You","2024-02-18",0],
    ["Triumphant Frenzy","2024-02-18",80],
    ["Triumphant Frenzy","2024-02-19",80],
    ["Xiao/Yae Trial","2024-02-20",40],
    ["Of Kites and New Sights","2024-02-20",160],
    ["Receiver of Friends From Afar","2024-02-21",105],
    ["Of Kites and New Sights","2024-02-22",160],
    ["Receiver of Friends From Afar","2024-02-23",105],
    ["Of Kites and New Sights","2024-02-24",160],
    ["Receiver of Friends From Afar","2024-02-25",105],
    ["Triumphant Frenzy","2024-02-26",0],
    ["Vibrant Harriers Aloft In Spring Breeze","2024-02-26",0],
    ["Receiver of Friends From Afar","2024-02-27",105],
    ["Journey Through Hilinigmatic Terrain","2024-02-29",60],
    ["4.5 Livestream Codes","2024-03-01",300],
    ["Journey Through Hilinigmatic Terrain","2024-03-29",60],
    ["4.5 Livestream Codes","2024-03-02",0],
    ["Journey Through Hilinigmatic Terrain","2024-03-02",60],
    ["Mihoyo Web Login","2024-03-03",20],
    ["Journey Through Hilinigmatic Terrain","2024-03-02",60],
    ["Receiver of Friends From Afar","2024-03-04",0],
    ["Journey Through Hilinigmatic Terrain","2024-03-04",60],
    ["Journey Through Hilinigmatic Terrain","2024-03-04",60],
    ["Journey Through Hilinigmatic Terrain","2024-03-06",60],
    ["Mihoyo Web Login","2024-03-10",20],
    ["Journey Through Hilinigmatic Terrain","2024-03-11",0],
    ["4.5 Patch Compensation","2024-03-12",600],
    ["Chiori/Itto Trial","2024-03-12",40],
    ["Chiori Story Quest","2024-03-12",60],
    ["Lynette Hangout","2024-03-12",60],
    ["Alchemical Ascension","2024-03-14",280],
    ["Alchemical Ascension","2024-03-16",280],
    ["Mihoyo Web Login","2024-03-17",20],
    ["Alchemical Ascension","2024-03-18",280],
    ["Alchemical Ascension","2024-03-20",160],
    ["The Great Fayz Reaction Debate","2024-03-22",60],
    ["The Great Fayz Reaction Debate","2024-03-23",60],
    ["The Great Fayz Reaction Debate","2024-03-24",60],
    ["The Great Fayz Reaction Debate","2024-03-25",60],
    ["The Great Fayz Reaction Debate","2024-03-26",60],
    ["The Great Fayz Reaction Debate","2024-03-27",60],
    ["The Great Fayz Reaction Debate","2024-03-28",60],
    ["Rolling Crossfire","2024-04-01",80],
    ["Alchemical Ascension","2024-04-01",0],
    ["Neuvillete/Kazuha Trial","2024-04-02",40],
    ["Rolling Crossfire","2024-04-02",80],
    ["The Great Fayz Reaction Debate","2024-04-03",0],
    ["Mihoyo Web Login","2024-04-03",20],
    ["Rolling Crossfire","2024-04-03",80],
    ["Rolling Crossfire","2024-04-04",80],
    ["Rolling Crossfire","2024-04-05",100],
    ["Feline Fortress Furrdyssey","2024-04-08",80],
    ["Feline Fortress Furrdyssey","2024-04-09",80],
    ["Mihoyo Web Login","2024-04-10",20],
    ["Feline Fortress Furrdyssey","2024-04-10",80],
    ["Feline Fortress Furrdyssey","2024-04-11",80],
    ["Feline Fortress Furrdyssey","2024-04-12",100],
    ["4.6 Livestream Codes","2024-04-12",300],
    ["4.6 Livestream Codes","2024-04-13",0],
    ["Mihoyo Web Login","2024-04-17",20],
    ["4.6 Patch Compensation","2024-04-23",600],
    ["Arlecchino/Lyney Trial","2024-04-23",40],
    ["Arlecchino Story Quest","2024-04-23",60],
    ["Vibro-Crystal Applications","2024-04-28",70],
    ["Vibro-Crystal Applications","2024-04-29",70],
    ["Vibro-Crystal Applications","2024-04-30",70],
    ["Vibro-Crystal Applications","2024-05-01",70],
    ["Vibro-Crystal Applications","2024-05-02",70],
    ["Vibro-Crystal Applications","2024-05-03",70],
    ["Mihoyo Web Login","2024-05-03",20],
    ["Iridescent Arataki Rockin' For Life Tour de Force of Awesomeness", "2024-05-06", 240],
    ["Iridescent Arataki Rockin' For Life Tour de Force of Awesomeness", "2024-05-07", 60],
    ["Iridescent Arataki Rockin' For Life Tour de Force of Awesomeness", "2024-05-08", 190],
    ["Vibro-Crystal Applications","2024-05-09",0],
    ["Iridescent Arataki Rockin' For Life Tour de Force of Awesomeness", "2024-05-09", 90],
    ["Iridescent Arataki Rockin' For Life Tour de Force of Awesomeness", "2024-05-10", 270],
    ["Mihoyo Web Login","2024-05-10",20],
    ["Iridescent Arataki Rockin' For Life Tour de Force of Awesomeness", "2024-05-11", 90],
    ["Iridescent Arataki Rockin' For Life Tour de Force of Awesomeness", "2024-05-12", 60],
    ["Wanderer/Baizhu Trial","2024-05-14",40],
    ["Cyno Story Quest 2","2024-05-14",60],
    ["Windtrace","2024-05-14",120],
    ["Windtrace","2024-05-15",100],
    ["Windtrace","2024-05-16",80],
    ["Windtrace","2024-05-17",80],
    ["Windtrace","2024-05-18",40],
    ["Mihoyo Web Login","2024-05-17",20],
    ["Specially-Shaped Saurian Search","2024-05-22",105],
    ["4.7 Livestream Codes","2024-05-24",300],
    ["Specially-Shaped Saurian Search","2024-05-24",105],
    ["4.7 Livestream Codes","2024-05-25",0],
    ["Specially-Shaped Saurian Search","2024-05-26",105],
    ["Iridescent Arataki Rockin' For Life Tour de Force of Awesomeness", "2024-05-27", 0],
    ["Specially-Shaped Saurian Search","2024-05-28",105],
    ["Mihoyo Web Login","2024-06-03",20],
    ["4.7 Patch Compensation","2024-06-04",600],
    ["Clorinde/Alhaitham Trial","2024-06-04",40],
    ["Archon Quest Act 4 Ch 6","2024-06-04",220],
    ["Clorinde Story Quest","2024-06-04",60],
    ["Mutual Security Enhancing Simulation","2024-06-07",420],
    ["Mutual Security Enhancing Simulation","2024-06-09",380],
    ["Mutual Security Enhancing Simulation","2024-06-11",200],
    ["Mihoyo Web Login","2024-06-10",20],
    ["Mihoyo Web Login","2024-06-17",20],
    ["Mutual Security Enhancing Simulation","2024-06-17",0],
    ["Record of Reflective Writing","2024-06-18",140],
    ["Record of Reflective Writing","2024-06-19",140],
    ["Record of Reflective Writing","2024-06-20",140],
    ["Record of Reflective Writing","2024-06-24",0],
    ["Sigewinne/Furina Trial","2024-06-25",40],
    ["Sigewinne Story Quest","2024-06-25",60],
    ["Endless Forms Most Martial","2024-06-25",100],
    ["Endless Forms Most Martial","2024-06-26",100],
    ["Endless Forms Most Martial","2024-06-27",100],
    ["Endless Forms Most Martial","2024-06-28",120],
    ["Endless Forms Most Martial","2024-07-01",0],
    ["Imaginarium Theater Debut","2024-07-01",100],
    ["Imaginarium Theater Debut","2024-07-01",100],
    ["Imaginarium Theater Debut","2024-07-01",200],
    ["Imaginarium Theater Debut","2024-07-01",100],
    ["Imaginarium Theater Debut","2024-07-01",100],
    ["Imaginarium Theater Debut","2024-07-01",200],
    ["Imaginarium Theater Debut","2024-07-01",100],
    ["Imaginarium Theater Debut","2024-07-01",200],
    ["Spino Doubleblaster","2024-07-02",120],
    ["Spino Doubleblaster","2024-07-03",100],
    ["Mihoyo Web Login","2024-07-03",20],
    ["Spino Doubleblaster","2024-07-04",100],
    ["Spino Doubleblaster","2024-07-05",100],
    ["4.8 Livestream Codes","2024-07-05",300],  
    ["4.8 Livestream Codes","2024-07-06",0],
    ["Spino Doubleblaster","2024-07-08",0],
    ["Mihoyo Web Login","2024-07-10",20],
    ["4.8 Patch Compensation","2024-07-16",600],
    ["Navia/Nilou Trial","2024-07-16",40],
    ["Summertime Scales and Tales","2024-07-16",300],
    ["Mihoyo Web Login","2024-07-17",20],
    ["Summertime Scales and Tales","2024-07-19",300],
    ["Summertime Scales and Tales","2024-07-21",240],
    ["Summertime Scales and Tales","2024-07-23",160],
    ["Outside the Canvas, Inside the Lens: Dew-Kissed Chapter","2024-07-29",60],
    ["Outside the Canvas, Inside the Lens: Dew-Kissed Chapter","2024-07-30",60],
    ["Outside the Canvas, Inside the Lens: Dew-Kissed Chapter","2024-08-01",60],
    ["Outside the Canvas, Inside the Lens: Dew-Kissed Chapter","2024-08-02",60],
    ["Outside the Canvas, Inside the Lens: Dew-Kissed Chapter","2024-08-03",60],
    ["Mihoyo Web Login","2024-08-03",20],
    ["Outside the Canvas, Inside the Lens: Dew-Kissed Chapter","2024-08-04",60],
    ["Outside the Canvas, Inside the Lens: Dew-Kissed Chapter","2024-08-05",60],
    ["Emilie/Yelan Trial","2024-08-06",40],
    ["Emilie Story Quest","2024-08-06",60],
    ["Bing-bang Finchball","2024-08-06",160],
    ["Bing-bang Finchball","2024-08-07",140],
    ["Outside the Canvas, Inside the Lens: Dew-Kissed Chapter","2024-08-08",0],
    ["Bing-bang Finchball","2024-08-08",90],
    ["Bing-bang Finchball","2024-08-09",30],
    ["Mihoyo Web Login","2024-08-10",20],
    ["Energy Amplifier","2024-08-12",70],
    ["Energy Amplifier","2024-08-13",70],
    ["Energy Amplifier","2024-08-14",70],
    ["Energy Amplifier","2024-08-15",70],
    ["Energy Amplifier","2024-08-16",70],
    ["Energy Amplifier","2024-08-17",70],
    ["4.8 Livestream Codes","2024-08-16",300],  
    ["4.8 Livestream Codes","2024-08-17",0],
    ["Mihoyo Web Login","2024-08-17",20],
    ["Bing-bang Finchball","2024-08-19",0],
    ["Best Mobile Game 2024","2024-08-26",200],
    ["5.0 Patch Compensation","2024-08-27",600],
    ["Mualani/Kazuha Trial","2024-08-27",40],
    ["Archon Quest Act 5 Ch 1","2024-08-27",220],
    ["Archon Quest Act 5 Ch 2","2024-08-27",720],
    ["Mualani Story Quest","2024-08-27",120],
    ["World 9 Ascension","2024-08-27",100],
    ["Traces of Artistry","2024-08-27",280],
    ["Best Mobile Game 2024","2024-08-27",200],
    ["Best Mobile Game 2024","2024-08-28",200],
    ["Best Mobile Game 2024","2024-08-29",200],
    ["Traces of Artistry","2024-08-30",340],
    ["Best Mobile Game 2024","2024-08-30",200],
    ["Anniversary: Brilliant Dawn","2024-08-30",160],
    ["Anniversary: Brilliant Dawn","2024-09-01",320],
    ["Imaginarium Theater Visionary Mode","2024-09-01",400],
    ["Traces of Artistry","2024-09-01",280],
    ["Anniversary: Brilliant Dawn","2024-09-03",320],
    ["Mihoyo Web Login","2024-09-03",20],
    ["Anniversary: Brilliant Dawn","2024-09-05",800],
    ["Dodoco's Boom-Bastic Escapades","2024-09-09",70],
    ["Dodoco's Boom-Bastic Escapades","2024-09-10",70],
    ["Mihoyo Web Login","2024-09-10",20],
    ["Dodoco's Boom-Bastic Escapades","2024-09-11",70],
    ["Dodoco's Boom-Bastic Escapades","2024-09-12",70],
    ["Dodoco's Boom-Bastic Escapades","2024-09-13",70],
    ["Dodoco's Boom-Bastic Escapades","2024-09-14",70],
    ["Traces of Artistry","2024-09-16",0],
    ["Mihoyo Web Login","2024-09-17",20],
    ["Kinich/Raiden Trial","2024-09-17",40],
    ["Kinich Story Quest","2024-09-17",120],
    ["Of Thorns and Crowns","2024-09-20",100],
    ["Of Thorns and Crowns","2024-09-21",80],
    ["Of Thorns and Crowns","2024-09-22",80],
    ["Of Thorns and Crowns","2024-09-23",80],
    ["Dodoco's Boom-Bastic Escapades","2024-09-23",0],
    ["Of Thorns and Crowns","2024-09-24",80],
    ["5.1 Livestream Codes","2024-09-27",300],  
    ["5.1 Livestream Codes","2024-09-28",0],
    ["Mementos of Teyvat","2024-09-28",60],
    ["Anniversary: Gift for a New Horizon","2024-09-28",400],
    ["Mementos of Teyvat","2024-09-29",60],
    ["Anniversary: Gift for a New Horizon","2024-09-29",400],
    ["Of Thorns and Crowns","2024-09-30",0],
    ["Mementos of Teyvat","2024-09-30",60],
    ["Anniversary: Gift for a New Horizon","2024-09-30",400],
    ["Mementos of Teyvat","2024-10-01",60],
    ["Anniversary: Gift for a New Horizon","2024-10-01",400],
    ["Mementos of Teyvat","2024-10-02",60],
    ["Mementos of Teyvat","2024-10-03",120],
    ["Mihoyo Web Login","2024-10-03",20],
    ["5.1 Patch Compensation","2024-10-08",600],
    ["Xilonen/Chiori Trial","2024-10-08",40],
    ["Archon Quest Act 5 Ch 3","2024-10-08",220],
    ["Archon Quest Act 5 Ch 4","2024-10-08",720],
    ["Xilonen Story Quest","2024-10-08",120],
    ["Between Pledge and Forgottence","2024-10-08",100],
    ["Natlan Exploration Bonus","2024-10-08",100],
    ["Natlan Exploration Bonus","2024-10-08",100],
    ["Natlan Exploration Bonus","2024-10-08",100],
    ["Mihoyo Web Login","2024-10-10",20],
    ["Adhid Treasure Trace","2024-10-10",100],
    ["Adhid Treasure Trace","2024-10-11",80],
    ["Adhid Treasure Trace","2024-10-12",80],
    ["Adhid Treasure Trace","2024-10-13",80],
    ["Adhid Treasure Trace","2024-10-14",80],
    ["Mihoyo Web Login","2024-10-17",20],
    ["Reminiscent Regimen: Thrill","2024-10-17",160],
    ["Reminiscent Regimen: Thrill","2024-10-18",140],
    ["Reminiscent Regimen: Thrill","2024-10-19",90],
    ["Reminiscent Regimen: Thrill","2024-10-20",30],
    ["Adhid Treasure Trace","2024-10-21",0],
    ["Chromatic Ode of Candies and Roses","2024-10-23",210],
    ["Chromatic Ode of Candies and Roses","2024-10-24",170],
    ["Chromatic Ode of Candies and Roses","2024-10-25",210],
    ["Chromatic Ode of Candies and Roses","2024-10-26",170],
    ["Chromatic Ode of Candies and Roses","2024-10-27",240],
    ["Reminiscent Regimen: Thrill","2024-10-28",0],
    ["Nahida/Hu Tao Trial","2024-10-29",40],
    ["Mihoyo Web Login","2024-11-03",20],
    ["Feast of Pursuit","2024-11-04",70],
    ["Feast of Pursuit","2024-11-05",70],
    ["Feast of Pursuit","2024-11-06",70],
    ["Feast of Pursuit","2024-11-07",70],
    ["Chromatic Ode of Candies and Roses","2024-11-07",0],
    ["Feast of Pursuit","2024-11-08",70],
    ["Feast of Pursuit","2024-11-09",70],
    ["Mihoyo Web Login","2024-11-10",20],
    ["Marvelous Merchandise","2024-11-11",40],
    ["Marvelous Merchandise","2024-11-12",40],
    ["Marvelous Merchandise","2024-11-13",40],
    ["Marvelous Merchandise","2024-11-14",40],
    ["Marvelous Merchandise","2024-11-15",140],
    ["Marvelous Merchandise","2024-11-16",40],
    ["Marvelous Merchandise","2024-11-17",40],
    ["Mihoyo Web Login","2024-11-17",20],
    ["5.2 Patch Compensation","2024-11-19",600],
    ["Chasca/Lyney Trial","2024-11-19",40],
    ["Archon Quest Act 5 Interlude","2024-11-19",190],
    ["Chasca Story Quest","2024-11-19",120],
    ["Lost Traveler in the Ashen Realm","2024-11-19",100],
    ["Natlan Exploration Bonus","2024-11-19",100],
    ["Natlan Exploration Bonus","2024-11-19",100],
    ["Natlan Exploration Bonus","2024-11-19",100],
    ["Claw Convoy", "2024-11-22", 70],
    ["Claw Convoy", "2024-11-23", 70],
    ["Claw Convoy", "2024-11-24", 70],
    ["Claw Convoy", "2024-11-25", 70],
    ["Claw Convoy", "2024-11-26", 70],
    ["Claw Convoy", "2024-11-27", 70],
    ["Iktomi Spiritseeking Scrolls", "2024-11-28", 220],
    ["Iktomi Spiritseeking Scrolls", "2024-11-30", 320],
    ["Iktomi Spiritseeking Scrolls", "2024-12-01", 240],
    ["Claw Convoy", "2024-12-02", 0],
    ["Iktomi Spiritseeking Scrolls", "2024-12-03", 220],
    ["Mihoyo Web Login","2024-12-03",20],
    ["Thank-You Letter","2024-12-04",200],
    ["Thank-You Letter","2024-12-05",200],
    ["Thank-You Letter","2024-12-06",200],
    ["Thank-You Letter","2024-12-07",200],
    ["Thank-You Letter","2024-12-08",200],
    ["Neuvillette/Zhongli Trial","2024-12-10",40],
    ["Mihoyo Web Login","2024-12-10",20],
    ["Adventurer's Trials: Metamorphosis","2024-12-11",105],
    ["Adventurer's Trials: Metamorphosis","2024-12-12",105],
    ["Adventurer's Trials: Metamorphosis","2024-12-13",105],
    ["Adventurer's Trials: Metamorphosis","2024-12-14",105],
    ["Iktomi Spiritseeking Scrolls", "2024-12-16", 0],
    ["Mihoyo Web Login","2024-12-17",20],
    ["Exercise Surging Storm","2024-12-18",220],
    ["Exercise Surging Storm","2024-12-20",80],
    ["5.3 Livestream Codes","2024-12-20",300],  
    ["5.3 Livestream Codes","2024-12-21",0],
    ["Exercise Surging Storm","2024-12-22",120],
    ["5.3 Patch Compensation","2024-12-31",600],
    ["Mauvika/Citali Trial","2024-12-31",40],
    ["Archon Quest Act 5 Ch 5","2024-12-31",750],
    ["Mauvika Story Quest","2024-12-31",120],
    ["Citali Story Quest","2024-12-31",120],
    ["Mihoyo Web Login","2025-01-03",20],
    ["Shuyu's Baffling Beetle Battle Bowl","2025-01-03",90],
    ["Shuyu's Baffling Beetle Battle Bowl","2025-01-04",90],
    ["Shuyu's Baffling Beetle Battle Bowl","2025-01-05",80],
    ["Shuyu's Baffling Beetle Battle Bowl","2025-01-06",80],
    ["Shuyu's Baffling Beetle Battle Bowl","2025-01-07",80],
    ["Emblem of Steadfast Valor","2025-01-09",70],
    ["Emblem of Steadfast Valor","2025-01-09",70],
    ["Mihoyo Web Login","2025-01-10",20],
    ["Emblem of Steadfast Valor","2025-01-11",70],
    ["Emblem of Steadfast Valor","2025-01-11",70],
    ["Emblem of Steadfast Valor","2025-01-13",70],
    ["Shuyu's Baffling Beetle Battle Bowl","2025-01-13",0],
    ["Emblem of Steadfast Valor","2025-01-13",70],
    ["On the Trail of Behemoths","2025-01-14",120],
    ["On the Trail of Behemoths","2025-01-16",100],
    ["On the Trail of Behemoths","2025-01-18",100],
    ["On the Trail of Behemoths","2025-01-20",100],
    ["Mihoyo Web Login","2025-01-17",20],
    ["Emblem of Steadfast Valor","2025-01-20",0],
    ["Arlecchino/Chlorine Trial","2025-01-21",40],
    ["May Fortune Find You: Spring's Premonition","2025-01-22",160],
    ["Springtime Charms","2025-01-24",280],
    ["May Fortune Find You: Spring's Premonition","2025-01-24",320],
    ["Springtime Charms","2024-01-26",330],
    ["May Fortune Find You: Spring's Premonition","2025-01-26",320],
    ["On the Trail of Behemoths","2025-01-27",0],
    ["Springtime Charms","2024-01-28",310],
    ["May Fortune Find You: Spring's Premonition","2025-01-28",800],
    ["Springtime Charms","2024-01-30",80],
    ["5.4 Livestream Codes","2025-01-31",300],  
    ["5.4 Livestream Codes","2025-02-01",0],
    ["May Fortune Find You: Spring's Premonition","2025-02-01",300],
    ["May Fortune Find You: Spring's Premonition","2025-02-02",300],
    ["May Fortune Find You: Spring's Premonition","2025-02-03",300],
    ["Mihoyo Web Login","2025-02-03",20],
    ["May Fortune Find You: Spring's Premonition","2025-02-04",300],
    ["May Fortune Find You: Spring's Premonition","2025-02-05",400],
    ["Mihoyo Web Login","2025-02-10",20],
    ["5.4 Patch Compensation","2025-02-11",600],
    ["Mizuki/Sigewinne Trial","2025-02-11",40],
    ["Mizuki Story Quest","2025-02-11",120],
    ["Travelers' Tales: Anthology Chapter","2025-02-11",30],
    ["Travelers' Tales: Anthology Chapter","2025-02-12",30],
    ["Travelers' Tales: Anthology Chapter","2025-02-13",30],
    ["Travelers' Tales: Anthology Chapter","2025-02-14",30],
    ["Enchanted Tales of the Mikawa Festival","2025-02-14",230],
    ["Enchanted Tales of the Mikawa Festival","2025-02-15",170],
    ["Enchanted Tales of the Mikawa Festival","2025-02-16",200],
    ["Mihoyo Web Login","2025-02-17",20],
    ["Mizuki's Hot Spring Therapy","2025-02-17",30],
    ["Enchanted Tales of the Mikawa Festival","2025-02-17",170],
    ["Enchanted Tales of the Mikawa Festival","2025-02-18",230],
    ["Realm of Tempered Valor","2025-02-24",80],
    ["Realm of Tempered Valor","2025-02-25",80],
    ["Realm of Tempered Valor","2025-02-26",80],
    ["Realm of Tempered Valor","2025-02-27",90],
    ["Realm of Tempered Valor","2025-02-28",90],
    ["Mihoyo Web Login","2025-03-03",20],
    ["Furina/Wriothesley Trial","2025-03-04",40],
    ["Invasive Fish Wrangler","2025-03-05",70],
    ["Invasive Fish Wrangler","2025-03-06",70],
    ["Invasive Fish Wrangler","2025-03-07",70],
    ["Invasive Fish Wrangler","2025-03-08",70],
    ["Invasive Fish Wrangler","2025-03-09",70],
    ["Invasive Fish Wrangler","2025-03-10",70],
    ["Mihoyo Web Login","2025-03-10",20],
    ["Reel Ad-Venture","2025-03-12",90],
    ["Reel Ad-Venture","2025-03-13",80],
    ["Reel Ad-Venture","2025-03-14",80],
    ["5.5 Livestream Codes","2025-03-14",300],
    ["5.5 Livestream Codes","2025-03-15",0],
    ["Reel Ad-Venture","2025-03-15",80],
    ["Reel Ad-Venture","2025-03-16",90],
    ["Mihoyo Web Login","2025-03-17",20],
    ["5.5 Patch Compensation","2025-03-25",600],
    ["Varesa/Xianyun Trial","2025-03-25",40],
    ["Varesa Story Quest","2025-03-25",120],
    ["The Lost Holy City and the Millennium Seeker","2025-03-25",100],
    ["Natlan Exploration Bonus","2025-03-25",100],
    ["Natlan Exploration Bonus","2025-03-25",100],
    ["Natlan Exploration Bonus","2025-03-25",100],
    ["Run, Varesa!","2025-03-25",30],
    ["A Tranquil Day","2025-03-25",80],
    ["Tournament of Glory in Bloom","2025-03-28",320],
    ["Tournament of Glory in Bloom","2025-03-30",320],
    ["Tournament of Glory in Bloom","2025-04-01",320],
    ["Mihoyo Web Login","2025-04-03",20],
    ["Unlimited Fighting Championship","2025-04-07",100],
    ["Unlimited Fighting Championship","2025-04-08",80],
    ["Unlimited Fighting Championship","2025-04-09",80],
    ["Unlimited Fighting Championship","2025-04-10",80],
    ["Mihoyo Web Login","2025-04-10",20],
    ["Unlimited Fighting Championship","2025-04-11",80],
    ["Tournament of Glory in Bloom","2025-04-14",0],
    ["Venti/Xilonen Trial","2025-04-15",40],
    ["Mihoyo Web Login","2025-04-17",20],
    ["Unlimited Fighting Championship","2025-04-21",0],
    ["Quirky Quaking Arena","2025-04-21",120],
    ["Quirky Quaking Arena","2025-04-22",120],
    ["Quirky Quaking Arena","2025-04-23",100],
    ["Quirky Quaking Arena","2025-04-24",80],
    ["5.6 Livestream Codes","2025-04-25",300],
    ["5.6 Livestream Codes","2025-04-26",0],
    ["Rhythm Ball Meztli","2025-04-28",70],
    ["Rhythm Ball Meztli","2025-04-29",70],
    ["Rhythm Ball Meztli","2025-04-30",70],
    ["Rhythm Ball Meztli","2025-05-01",70],
    ["Rhythm Ball Meztli","2025-05-02",70],
    ["Quirky Quaking Arena","2025-05-02",0],
    ["Rhythm Ball Meztli","2025-05-03",70],
    ["Mihoyo Web Login","2025-05-03",20],
    ["5.6 Patch Compensation","2025-05-06",600],
    ["Escoffier/Naiva Trial","2025-05-06",40],
    ["Escoffier Story Quest","2025-05-06",120],
    ["Archon Quest Interlude Act 4","2025-05-06",220],
    ["Whirling Waltz","2025-05-09",310],
    ["Mihoyo Web Login","2025-05-10",20],
    ["Whirling Waltz","2025-05-11",340],
    ["Whirling Waltz","2025-05-13",340],
    ["Mihoyo Web Login","2025-05-17",20],
    ["Operation Downpour Simulation","2025-05-19",80],
    ["Operation Downpour Simulation","2025-05-21",120],
    ["Operation Downpour Simulation","2025-05-23",220],
    ["Whirling Waltz","2025-05-26",0],
    ["Kinich/Raiden Trial","2025-05-27",40],
    ["Chronicle of Shifting Stratagems","2025-05-27",70],
    ["Chronicle of Shifting Stratagems","2025-05-28",70],
    ["Chronicle of Shifting Stratagems","2025-05-29",70],
    ["Chronicle of Shifting Stratagems","2025-05-30",70],
    ["Chronicle of Shifting Stratagems","2025-05-31",70],
    ["Chronicle of Shifting Stratagems","2025-06-01",70],
    ["Operation Downpour Simulation","2025-06-03",0],
    ["Mihoyo Web Login","2025-06-03",20],
    ["Legends Ablaze: Cross-Border Brawl","2025-06-05",180],
    ["Legends Ablaze: Cross-Border Brawl","2025-06-07",160],
    ["Legends Ablaze: Cross-Border Brawl","2025-06-09",80],
    ["Chronicle of Shifting Stratagems","2025-06-09",0],
    ["Mihoyo Web Login","2025-06-10",20],
    ["Legends Ablaze: Cross-Border Brawl","2025-06-16",0],
    ["Mihoyo Web Login","2025-06-17",20],
    ["5.7 Patch Compensation","2025-06-17",600],
    ["Skirk/Shenhe Trial","2025-06-17",40],
    ["Skirk Story Quest","2025-06-17",120],
    ["Archon Quest Act 5 Ch 6","2025-05-06",220],
    ["Through Yesterdays, to Today","2025-06-17",160],
    ["Travelers' Tales: Gilded Chapter","2025-06-17",30],
    ["Travelers' Tales: Gilded Chapter","2025-06-18",30],
    ["Swing your Sword 3 Million Times","2025-06-19",40],
    ["Travelers' Tales: Gilded Chapter","2025-06-19",30],
    ["Travelers' Tales: Gilded Chapter","2025-06-20",30],
    ["Battle of Imagined Arrays","2025-06-20",350],
    ["Battle of Imagined Arrays","2025-06-21",150],
    ["Battle of Imagined Arrays","2025-06-22",220],
    ["Battle of Imagined Arrays","2025-06-20",250],
    ["Swing your Sword 3 Million Times","2025-06-25",0],
    ["Stygian Onslaught","2025-06-25",450],
    ["Through Yesterdays, to Today","2025-07-02",0],
    ["Mihoyo Web Login","2025-07-03",20],
    ["Battle of Imagined Arrays","2025-07-07",0],
    ["Mavuika/Emilie Trial","2025-07-08",40],
    ["Mihoyo Web Login","2025-07-10",20],
    ["Reminiscent Regimen: Frenzy","2025-07-14",200],
    ["Reminiscent Regimen: Frenzy","2025-07-16",160],
    ["Reminiscent Regimen: Frenzy","2025-07-18",60],
    ["Mihoyo Web Login","2025-07-17",20],
    ["5.8 Livestream Codes","2025-07-18",300],
    ["5.8 Livestream Codes","2025-07-19",0],
    ["Fearsome Ferocious Firepower","2025-07-21",100],
    ["Fearsome Ferocious Firepower","2025-07-22",80],
    ["Fearsome Ferocious Firepower","2025-07-23",80],
    ["Fearsome Ferocious Firepower","2025-07-24",80],
    ["Reminiscent Regimen: Frenzy","2025-07-24",0],
    ["Fearsome Ferocious Firepower","2025-07-25",80],
    ["5.8 Patch Compensation","2025-07-29",600],
    ["Ineffa/Citlali Trial","2025-07-29",40],
    ["Archon Quest Act Moon Prelude","2025-07-29",220],
    ["Sunspray Summer Resort","2025-07-29",300],
    ["Natlan: Plains of Flowing Flames","2025-07-29",60],
    ["Sunspray Summer Resort Bonus","2024-07-29",100],
    ["Natlan Exploration Bonus","2024-07-29",100],
    ["Natlan Exploration Bonus","2024-07-29",100],
    ["Natlan Exploration Bonus","2024-07-29",100],
    ["Sunspray Summer Resort","2025-08-01",230],
    ["Ineffa's Emotional Care","2025-08-01",30],
    ["Sunspray Summer Resort","2025-08-03",290],
    ["Sunspray Summer Resort","2025-08-05",180],
    ["Mihoyo Web Login","2025-08-03",20],
    ["Stygian Onslaught","2025-08-06",450],
    ["Mihoyo Web Login","2025-08-10",20],
    ["Ineffa's Emotional Care","2025-08-10",0],
    ["Tracing Vanishing Trails","2025-08-14",140],
    ["Tracing Vanishing Trails","2025-08-16",140],
    ["Mihoyo Web Login","2025-08-17",20],
    ["Tracing Vanishing Trails","2025-08-18",140],
    ["Sunspray Summer Resort","2025-08-18",0],
    ["Mualani/Chasca Trial","2025-08-19",40],
    ["Mementos of Teyvat: Prelude of the Frozen Veil","2025-08-21",60],
    ["Mementos of Teyvat: Prelude of the Frozen Veil","2025-08-22",60],
    ["Mementos of Teyvat: Prelude of the Frozen Veil","2025-08-23",60],
    ["Mementos of Teyvat: Prelude of the Frozen Veil","2025-08-24",60],
    ["Tracing Vanishing Trails","2025-08-25",0],
    ["Mementos of Teyvat: Prelude of the Frozen Veil","2025-08-25",60],
    ["Mementos of Teyvat: Prelude of the Frozen Veil","2025-08-26",120],
    ["6.0 Livestream Codes","2025-08-29",300],
    ["6.0 Livestream Codes","2025-08-30",0],
    ["Mementos of Teyvat: Prelude of the Frozen Veil","2025-09-01",0],
    ["Mihoyo Web Login","2025-09-03",20],
    ["6.0 Patch Compensation","2025-09-09",600],
    ["Archon Quest Act Moon 1","2025-09-09",220],
    ["Archon Quest Act Moon 2","2025-09-09",720],
    ["The Shoemaker's Children Go Barefoot","2025-09-09",100],
    ["Nod Krai Exploration Bonus","2025-09-09",100],
    ["Nod Krai Exploration Bonus","2025-09-09",100],
    ["Nod Krai Exploration Bonus","2025-09-09",100],
    ["Rhythm Game - Encounter Memories of Boundless Journey","2025-09-09",60],
    ["It Starts In Nod Krai","2025-09-09",100],
    ["Lauma/Nahida Trial","2025-09-09",40],
    ["Mihoyo Web Login","2025-09-10",20],
    ["Clink Clank Clash","2025-09-12",340],
    ["Clink Clank Clash","2025-09-14",340],
    ["Clink Clank Clash","2025-09-16",310],
    ["Mihoyo Web Login","2025-09-17",20],
    ["Stygian Onslaught","2025-09-17",450],
    ["It Starts In Nod Krai","2025-09-24",0],
    ["Annivesary Special Favorite Things","2025-09-24",30],
    ["Annivesary Special Favorite Things","2025-09-28",0],
    ["Tracing the Hearts Journey","2025-09-28",180],
    ["Anniversary Missive of Grace","2025-09-28",400],
    ["Anniversary Missive of Grace","2025-09-29",400],
    ["Dodoco's Blow-Up-Erative Bomb-Nanza","2025-09-29",240],
    ["Clink Clank Clash","2025-09-29",0],
    ["Anniversary Missive of Grace","2025-09-30",400],
    ["Flins/Yelan Trial","2025-09-30",40],
    ["Anniversary Missive of Grace","2025-10-01",400],
    ["Anniversary Silvery Flux","2025-10-01",160],
    ["Imaginarum Theater Lunar First Clear","2025-10-01",300],
    ["Dodoco's Blow-Up-Erative Bomb-Nanza","2025-10-01",60],
    ["Dodoco's Blow-Up-Erative Bomb-Nanza","2025-10-03",60],
    ["Mihoyo Web Login","2025-10-03",20],
    ["Anniversary Silvery Flux","2025-10-03",320],
    ["Dodoco's Blow-Up-Erative Bomb-Nanza","2025-10-05",60],
    ["Anniversary Silvery Flux","2025-10-05",320],
    ["Anniversary Silvery Flux","2025-10-07",800],
    ["Mihoyo Web Login","2025-10-10",20],
    ["Lightgleaner's Journey","2025-10-10",70],
    ["6.1 Livestream Codes","2025-10-10",300],
    ["6.1 Livestream Codes","2025-10-11",0],
    ["Lightgleaner's Journey","2025-10-11",70],
    ["Tracing the Hearts Journey","2025-10-12",0],
    ["Lightgleaner's Journey","2025-10-12",70],
    ["Dodoco's Blow-Up-Erative Bomb-Nanza","2025-10-13",0],
    ["Lightgleaner's Journey","2025-10-13",70],
    ["Lightgleaner's Journey","2025-10-14",70],
    ["Lightgleaner's Journey","2025-10-15",70],
    ["Mihoyo Web Login","2025-10-17",20],
    ["6.1 Patch Compensation","2025-10-21",720],
    ["Nefer/Furina Trial","2025-10-21",40],
    ["Archon Quest Act Moon 3","2025-10-21",190],
    ["Archon Quest Act Moon 4","2025-10-21",750],
    ["Starbound Oath","2025-10-21",40],
    ["Saurian Sojourn","2025-10-24",100],
    ["Saurian Sojourn","2025-10-25",80],
    ["Saurian Sojourn","2025-10-26",80],
    ["Saurian Sojourn","2025-10-27",80],
    ["Saurian Sojourn","2025-10-28",80],
    ["Stygian Onslaught","2025-10-29",450],
    ["Saurian Sojourn","2025-11-03",0],
    ["Mihoyo Web Login","2025-11-03",20],
    ["Ruins Exploration: Fieldwise Center","2025-11-07",310],
    ["Ruins Exploration: Fieldwise Center","2025-11-09",330],
    ["Mihoyo Web Login","2025-11-10",20],
    ["Ruins Exploration: Fieldwise Center","2025-11-11",320],
    ["Arleccino/Zhongli Trial","2025-11-11",40],
    ["Mihoyo Web Login","2025-11-17",20],
    ["Dance Dance Dynamic Disco","2025-11-17",120],
    ["Dance Dance Dynamic Disco","2025-11-19",100],
    ["Dance Dance Dynamic Disco","2025-11-21",100],
    ["6.2 Livestream Codes","2025-11-21",300],
    ["6.2 Livestream Codes","2025-11-22",0],
    ["Dance Dance Dynamic Disco","2025-11-23",100],
    ["Ruins Exploration: Fieldwise Center","2025-11-24",0],
    ["Dance Dance Dynamic Disco","2025-11-26",0],
    ["6.2 Patch Compensation","2025-12-02",600],
    ["Archon Quest Act Moon 5","2025-12-02",190],
    ["Archon Quest Act Moon 6","2025-12-02",870],
    ["Durin Story Quest","2025-12-02",120],
    ["Durin/Venti Trial","2025-12-02",40],
    ["Mili Snow Resort Party in Wonderland","2025-12-02",40],
    ["Mihoyo Web Login","2025-12-03",20],
    ["Bing-Bang Finchball","2025-12-05",120],
    ["Bing-Bang Finchball","2025-12-06",100],
    ["Bing-Bang Finchball","2025-12-07",100],
    ["Bing-Bang Finchball","2025-12-08",100],
    ["Stygian Onslaught","2025-12-10",450],
    ["Mihoyo Web Login","2025-12-10",20],
    ["Bing-Bang Finchball","2025-12-15",0],
    ["Mihoyo Web Login","2025-12-17",20],
    ["Soulblazers Snowbound Journey","2025-12-19",370],
    ["Soulblazers Snowbound Journey","2025-12-21",330],
    ["Soulblazers Snowbound Journey","2025-12-23",390],
    ["Varesa/Xilonen Trial","2025-12-23",40],
    ["Heroic Clash: Saurian Brawl","2025-12-29",120],
    ["Heroic Clash: Saurian Brawl","2025-12-30",100],
    ["Heroic Clash: Saurian Brawl","2025-12-31",100],
    ["Heroic Clash: Saurian Brawl","2026-01-01",100],
    ["6.3 Livestream Codes","2026-01-02",300],
    ["6.3 Livestream Codes","2026-01-03",0],
    ["Mihoyo Web Login","2026-01-03",20],
    ["Soulblazers Snowbound Journey","2026-01-05",0],
    ["Marvelous Merchandise","2026-01-05",40],
    ["Marvelous Merchandise","2026-01-06",40],
    ["Heroic Clash: Saurian Brawl","2026-01-07",0],
    ["Marvelous Merchandise","2026-01-07",40],
    ["Marvelous Merchandise","2026-01-08",40],
    ["Marvelous Merchandise","2026-01-09",140],
    ["Marvelous Merchandise","2026-01-10",40],
    ["Mihoyo Web Login","2026-01-10",20],
    ["Marvelous Merchandise","2026-01-11",40],
    ["Where the Moon Returns||Community","2026-01-12",40],
    ["6.3 Patch Compensation","2026-01-13",600],
    ["Archon Quest Act Moon 7","2026-01-13",190],
    ["Archon Quest Act Moon 8","2026-01-13",750],
    ["Nightingale's Song","2026-01-13",100],
    ["Nod Krai Exploration Bonus","2026-01-13",100],
    ["Nod Krai Exploration Bonus","2026-01-13",100],
    ["Nod Krai Exploration Bonus","2026-01-13",100],
    ["A Gift From The Sea Spirits","2026-01-13",30],
    ["Columbina/Ineffa Trial","2026-01-13",40],
    ["Where the Moon Returns||Web","2026-01-14",20],
    ["Shutterflash Memory Hunt","2026-01-16",100],
    ["May Fortune Find You: Spring's Premonition","2026-01-16",160],
    ["Shutterflash Memory Hunt","2026-01-17",80],
    ["Mihoyo Web Login","2026-01-17",20],
    ["May Fortune Find You: Spring's Premonition","2026-01-18",320],
    ["Shutterflash Memory Hunt","2026-01-18",80],
    ["Shutterflash Memory Hunt","2026-01-19",80],
    ["Shutterflash Memory Hunt","2026-01-20",80],
    ["May Fortune Find You: Spring's Premonition","2026-01-20",320],
    ["Stygian Onslaught","2026-01-21",450],
    ["May Fortune Find You: Spring's Premonition","2026-01-22",800],
    ["May Fortune Find You: Spring's Premonition","2026-01-30",300],
    ["A Laternlit Ode to the Silver Moon","2026-01-30",280],
    ["May Fortune Find You: Spring's Premonition","2026-01-31",300],
    ["A Laternlit Ode to the Silver Moon","2026-02-01",330],
    ["May Fortune Find You: Spring's Premonition","2026-02-01",300],
    ["May Fortune Find You: Spring's Premonition","2026-02-02",300],
    ["May Fortune Find You: Spring's Premonition","2026-02-03",400],
    ["A Laternlit Ode to the Silver Moon","2026-02-03",310],
    ["Zibai/Neuvilette Trial","2026-02-03",40],
    ["Mihoyo Web Login","2026-02-03",20],
    ["A Laternlit Ode to the Silver Moon","2026-02-05",140],
    ["Moonlit Patrol Exercise","2026-02-09",100],
    ["Moonlit Patrol Exercise","2026-02-10",80],
    ["Mihoyo Web Login","2026-02-10",20],
    ["Moonlit Patrol Exercise","2026-02-11",80],
    ["Moonlit Patrol Exercise","2026-02-12",80],
    ["Moonlit Patrol Exercise","2026-02-13",80],
    ["6.4 Livestream Codes","2026-02-13",300],
    ["6.4 Livestream Codes","2026-02-14",0],
    ["Mihoyo Web Login","2026-02-17",20],
    ["6.4 Patch Compensation","2026-02-24",600],
    ["Varka/Flins Trial","2026-02-24",40],
    ["Varka Story Quest","2026-02-24",120],
    ["Rhythm Game - Nod-Krai: Gateway to the Borderland Elysium","2026-02-24",60],
    ["Miliastra - Wonderland Treasures","2026-02-24",60],
    ["Challenge Varka","2026-02-25",30],
    ["Homeward, He Who Caught the Wind","2026-02-27",290],
    ["Homeward, He Who Caught the Wind","2026-03-01",290],
    ["Mihoyo Web Login","2026-03-03",20],
    ["Homeward, He Who Caught the Wind","2026-03-03",310],
    ["Stygian Onslaught","2026-03-04",450],
    ["Homeward, He Who Caught the Wind","2026-03-05",70],
    ["Mihoyo Web Login","2026-03-10",20],
    ["Sightseeing With Friends","2026-03-16",160],
    ["Sightseeing With Friends","2026-03-17",130],
    ["Mihoyo Web Login","2026-03-17",20],
    ["Skirk/Escoffier Trial","2026-03-17",40],
    ["Sightseeing With Friends","2026-03-18",130],
    ["Operation Stronghold Defense","2026-03-23",70],
    ["Operation Stronghold Defense","2026-03-24",70],
    ["Operation Stronghold Defense","2026-03-25",70],
    ["Operation Stronghold Defense","2026-03-26",70],
    ["Operation Stronghold Defense","2026-03-27",70],
    ["6.5 Livestream Codes","2026-03-27",300],
    ["6.5 Livestream Codes","2026-03-28",0],
    ["Operation Stronghold Defense","2026-03-28",70],
    ["Mihoyo Web Login","2026-04-03",20],
    ["6.5 Patch Compensation","2026-04-07",600],
    ["Linnea/Chasca Trial","2026-04-07",40],
    ["Fairy Girl's Album","2026-04-08",30],
    ["Trail of Footsteps","2026-04-08",100],
    ["Mihoyo Web Login","2026-04-10",20],
    ["Surveying & Mapping Studies","2026-04-10",140],
    ["Surveying & Mapping Studies","2026-04-11",70],
    ["Surveying & Mapping Studies","2026-04-12",70],
    ["Surveying & Mapping Studies","2026-04-13",70],
    ["Surveying & Mapping Studies","2026-04-14",70],
    ["Stygian Onslaught","2026-04-15",450],
    ["Mihoyo Web Login","2026-04-17",20],
    ["Surveying & Mapping Studies","2026-04-20",0],
    ["Where Waves Meet the Reef","2026-04-27",330],
    ["Lauma/Nefer Trial","2026-04-28",40],
    ["Where Waves Meet the Reef","2026-04-29",380],
    ["Where Waves Meet the Reef","2026-05-01",260],
    ["Mihoyo Web Login","2026-05-03",20],
    ["Rapid Capture","2026-05-06",60],
    ["Rapid Capture","2026-05-07",60],
    ["Rapid Capture","2026-05-08",60],
    ["6.6 Livestream Codes","2026-05-08",300],
    ["6.6 Livestream Codes","2026-05-09",0],
    ["Rapid Capture","2026-05-09",60],
    ["Rapid Capture","2026-05-10",60],
    ["Mihoyo Web Login","2026-05-10",20],
    ["Rapid Capture","2026-05-11",60],
    ["Rapid Capture","2026-05-12",60],
    ["Mihoyo Web Login","2026-05-17",20],
    ["Rapid Capture","2026-05-18",0],
    ["6.6 Patch Compensation","2026-05-19",600],
    ["Nicole/Durin Trial","2026-05-19",40],
    ["Archon Quest Act Moon 9","2026-05-19",190],
    ["Archon Quest Act Moon 10","2026-05-19",750],
    ["Rhythm Game - Hexerei: Ballad of Whimsical Polyphony","2026-05-19",60],
    ["Nicole Story Workshop","2026-05-19",30],
    ["Mage Nicole's Tea Party","2026-05-20",20],
    ["Phantasmal Pals","2026-05-22",240],
    ["Phantasmal Pals","2026-05-24",270],
    ["Phantasmal Pals","2026-05-26",400],
    ["Nicole Story Workshop","2026-05-27",0],
    ["Stygian Onslaught","2026-05-27",450],
    ["Mage Nicole's Tea Party","2026-06-02",20],
    ["Mihoyo Web Login","2026-06-03",20],
    ["Trials of the Brave Warrior","2026-06-08",90],
    ["Lohen/Mavuika Trial","2026-06-09",40],
    ["Lohen Story Quest","2026-06-09",120],
    ["Trials of the Brave Warrior","2026-06-09",50],
    ["Trials of the Brave Warrior","2026-06-10",90],
    ["Mihoyo Web Login","2026-06-10",20],
    ["Miliastra Gifts","2026-06-10",270],
    ["Trials of the Brave Warrior","2026-06-11",50],
    ["Trials of the Brave Warrior","2026-06-12",90],
    ["Trials of the Brave Warrior","2026-06-13",50],
    ["Mihoyo Web Login","2026-06-17",20],
    ["Trials of the Brave Warrior","2026-06-18",0],
    ["Kaleidoscopic Color Chase","2026-06-18",180],
    ["6.7 Livestream Codes","2026-06-18",300],
    ["6.7 Livestream Codes","2026-06-19",0],
    ["Kaleidoscopic Color Chase","2026-06-20",160],
    ["Kaleidoscopic Color Chase","2026-06-22",80],
    ["Miliastra Gifts","2026-06-24",270],
    ["Kaleidoscopic Color Chase","2026-06-29",0],
    ["6.7 Patch Compensation","2026-06-30",600],
    ["Sandrone/Citlali Trial","2026-06-30",40],
    ["Rhythm Game - Nod Krai: Where Roads are Pledged to Cross","2026-06-30",60],
    ["Moon Gazing","2026-06-30",100],
    ["Moon Exploration Bonus","2026-06-30",100],
    ["Moon Exploration Bonus","2026-06-30",100],
    ["Moon Exploration Bonus","2026-06-30",100],
    ["Sunny Summer Fontinalia","2026-06-30",1060],
    ["Mihoyo Web Login","2026-07-03",20],
    ["Stygian Onslaught","2026-07-08",450],
    ["Mihoyo Web Login","2026-07-10",20],
    ["Mihoyo Web Login","2026-07-17",20],
    ["To Temper Thyself and Journey Far Extra","2026-07-17",20],
    ["Final Long-Range Sightlines","2026-07-17",70],
    ["Final Long-Range Sightlines","2026-07-18",70],
    ["Final Long-Range Sightlines","2026-07-19",70],
    ["Final Long-Range Sightlines","2026-07-20",70],
    ["Final Long-Range Sightlines","2026-07-21",70],
    ["Columbina/Raiden Trial","2026-07-21",40],
    ["Final Long-Range Sightlines","2026-07-22",70],
    ["To Temper Thyself and Journey Far Extra","2026-07-24",20],
    ["Dance Dance Easy-Breezy Disco","2026-07-24",120],
    ["Dance Dance Easy-Breezy Disco","2026-07-26",100],
    ["Final Long-Range Sightlines","2026-07-27",0],
    ["Dance Dance Easy-Breezy Disco","2026-07-28",100],
    ["Dance Dance Easy-Breezy Disco","2026-07-30",100],
    ["To Temper Thyself and Journey Far Extra","2026-07-31",20],
    ["7.0 Livestream Codes","2026-07-31",300],
    ["7.0 Livestream Codes","2026-08-01",0],
    ["Mihoyo Web Login","2026-08-03",20],
    ["Dance Dance Easy-Breezy Disco","2026-08-03",0],
    ["To Temper Thyself and Journey Far Extra","2026-08-07",20],
    ["Mihoyo Web Login","2026-08-10",20],
    ["7.0 Patch Compensation","2026-08-11",600],
    ["Odette/Arlecchino Trial","2026-08-11",40],
    ["Archon Quest Act 6 Ch 1","2026-08-11",190],
    ["Archon Quest Act 6 Ch 2","2026-08-11",750],
    ["Her Palace Collapses Into the Blizzard","2026-08-11",100],
    ["Snezhnaya Exploration Bonus","2026-08-11",100],
    ["Snezhnaya Exploration Bonus","2026-08-11",100],
    ["Snezhnaya Exploration Bonus","2026-08-11",100],
    ["Snezhnaya Awaits","2026-08-11",80],
    ["Miliastra Wonderland Treasures","2026-08-11",60],
    ["Mutual Aid in Bloom","2026-08-11",420],
    ["MySnezhnayaCareer","2026-08-13",160],
    ["Mihoyo Web Login","2026-08-17",20],
    ["Stygian Onslaught","2026-08-19",450],
    ["MySnezhnayaCareer","2026-08-24",0],
    ["Mutual Aid in Bloom","2026-08-24",0],
    ["Great Expeditionist Challenge","2026-08-28",230],
    ["Great Expeditionist Challenge","2026-08-30",230],
    ["Flins/Ineffa Trial","2026-09-01",40],
    ["Great Expeditionist Challenge","2026-09-01",230],
    ["Great Expeditionist Challenge","2026-09-03",230],
    ["Mihoyo Web Login","2026-09-03",20],
    ["Trial of the Bastion","2026-09-07",100],
    ["Trial of the Bastion","2026-09-08",80],
    ["Trial of the Bastion","2026-09-09",80],
    ["Trial of the Bastion","2026-09-10",80],
    ["Mihoyo Web Login","2026-09-10",20],
    ["Trial of the Bastion","2026-09-11",80],
    ["7.1 Livestream Codes","2026-09-11",300],
    ["7.1 Livestream Codes","2026-09-12",0],
    ["Great Expeditionist Challenge","2026-09-14",0],
    ["Trial of the Bastion","2026-09-17",0],
    ["Mihoyo Web Login","2026-09-17",20],
];